// 小王子
// 共 424 个单词

export default [
  {
    id: 1,
    word: "avoir",
    phonetic: "[avwar]",
    type: "",
    translation: "v.t. \u6709\uff1b\u662f\uff1bn.m. \u8d22\u4ea7\uff0c\u8d44\u4ea7\uff0c\u6240\u6709\u7269\uff1b\u8d37\u65b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 2,
    word: "sans",
    phonetic: "[s\u0251\u0303]",
    type: "",
    translation: "pr\u00e9p. \u6ca1\u6709\uff0c\u65e0\uff0c\u4e0d pr\u00e9p. \u548c\uff0c\u540c\uff0c\u8ddf\uff0c\u4e0e\uff1b\u7528\uff0c\u4f7f\u7528\uff1b\u968f\u7740\uff1b\u7531\u4e8e\uff0c\u56e0\u4e3a\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 3,
    word: "avec",
    phonetic: "[av\u03b5k]",
    type: "",
    translation: "\u5bf9\u4e8e\uff1b\u5e26\u6709\uff0c\u5177\u6709\uff1b\u5c3d\u7ba1 pron.relat. \u8c01\uff0c\u4ec0\u4e48\u4eba\uff1b\u90a3\u4e2a\uff08\u4eba\u3001\u4e8b\u3001\u7269\uff09\uff1b\u90a3\u4e9b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 4,
    word: "qui",
    phonetic: "[ki]",
    type: "",
    translation: "\uff08\u4eba\u3001\u4e8b\u3001\u7269\uff09\uff1b\u4efb\u4f55\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 5,
    word: "parler",
    phonetic: "[parle]",
    type: "",
    translation: "v.i. \u8bf4\uff1b\u8bb2\u8bdd\uff1bv.t. \u8bf4\uff0c\u8bb2\uff08\u67d0\u79cd\u8bed\u8a00\uff09 adj.num.card.\uff0c adj.inv. \u516d\uff1b\uff08\u4e00\u4e2a\u6708\u4efd\u7684\uff096\u65e5\uff1b6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 6,
    word: "six",
    phonetic: "[sis]",
    type: "",
    translation: "\u70b9\u949f\uff1b\uff08\u623f\u5c4b\u6216\u623f\u95f4\u7684\uff096\u53f7\uff1b\uff08\u7eb8\u724c\u7b49\u7684\uff09\u516d\u70b9\uff1b\u4e00\u79cd \u53e4\u94dc\u5e01 adj.ind\u00e9f. \u67d0\u4e00\u4e2a\uff0c\u4e00\u4e2a\uff1b\u67d0\u4e9b\uff0c\u5c11\u8bb8\uff1b\u5927\u7ea6\uff0c\u5c06\u8fd1[\u53ea",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 7,
    word: "quelque",
    phonetic: "[k\u03b5lk\u0259]",
    type: "",
    translation: "ou [k\u03b5lk] \u4fee\u9970\u6570\u8bcd]\uff1bpl.\u51e0\u4e2a\uff1b\u5c11\u91cf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 8,
    word: "chose",
    phonetic: "[\u222boz]",
    type: "",
    translation: "n.f. \u4e8b\u60c5\uff0c\u4e8b\u7269\uff1b\u4e8b\u5b9e\uff1b\u4e8b\u6001\uff1b\u4e1c\u897f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 9,
    word: "mon",
    phonetic: "[m\u0254\u0303, ma, me]",
    type: "",
    translation: "adj.poss. \u6211\u7684 conj. \u597d\u50cf\uff0c\u5982\u540c\uff0c\u72b9\u5982\uff1b\u7b80\u76f4\uff0c\u53ef\u4ee5\u8bf4\uff1b\u4f5c\u4e3a\uff0c\u5f53\u4f5c\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 10,
    word: "comme",
    phonetic: "[k\u0254m]",
    type: "",
    translation: "\u4f8b\u5982\uff1b\u7531\u4e8e\uff0c\u56e0\u4e3a\uff1b\u65e2\u7136\uff1b\u591a\u4e48\uff1b\u600e\u4e48\uff0c\u600e\u6837",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 11,
    word: "essayer",
    phonetic: "[ese(\u03b5)je]",
    type: "",
    translation: "v.t. \u8bd5\u9a8c\uff0c\u68c0\u9a8c\uff1b\u8bd5\u7a7f\uff1b\u8bd5\u7528 12 toute \uff08\u9634\u6027\uff09\u4efb\u4f55\uff0c\u6bcf\u4e00\u4e2a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 12,
    word: "difficile",
    phonetic: "[difisil]",
    type: "",
    translation: "a. \u96be\u7684\uff0c\u56f0\u96be\u7684\uff1b\u8270\u8f9b\u7684\uff1b\u96be\u4ee5\u76f8\u5904\u7684\uff0c\u96be\u4ee5\u6ee1\u8db3\u7684 pr\u00e9p. \u4e3a\u4e86\uff1b\u5bf9\u4e8e\uff1b\u9002\u5408\u4e8e\uff1b\u5411\uff0c\u5f80\uff1b\u5728\u2026\u2026\u65f6\u95f4\u5185\uff1b\u7531",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 13,
    word: "pour",
    phonetic: "[pur]",
    type: "",
    translation: "\u4e8e\uff1b\u4f9d\u2026\u2026\u770b\u6765\uff1b\u81f3\u4e8e\uff1b\u6362\uff0c\u6bd4\uff1b\u4ee3\uff0c\u66ff",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 14,
    word: "question",
    phonetic: "[k\u03b5stj\u0254\u0303]",
    type: "",
    translation: "n.f. \u95ee\u9898\uff0c\u95ee\u8bdd\uff1b\u8003\u9898 n.f. \u751f\u547d\uff1b\u751f\u547d\u529b\uff0c\u6d3b\u529b\uff1b\u4e00\u751f\uff1b\u751f\u6d3b\uff1b\u751f\u5e73\uff0c\u751f\u6daf\uff1b\u751f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 15,
    word: "vie",
    phonetic: "[vi]",
    type: "",
    translation: "\u5e73\u4e8b\u8ff9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 16,
    word: "mourir",
    phonetic: "[murir]",
    type: "",
    translation: "v.i. \u6b7b\u4ea1\uff1b\uff08\u690d\u7269\uff09\u67af\u6b7b\uff1b\u51cb\u8c22\uff1b\u9010\u6e10\u6d88\u5931\uff0c\u706d\u4ea1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 17,
    word: "eau",
    phonetic: "[o]",
    type: "",
    translation: "n.f. \u6c34\uff1b\u6d77\uff1b\u6e56\uff1b\u6cb3\uff1b\u6c60\u5858\uff1b\u836f\u6c34\uff1b\u6eb6\u6db2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 18,
    word: "boire",
    phonetic: "[bwar]",
    type: "",
    translation: "v.t. \u559d\uff0c\u996e\uff1b\u5438\u6536",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 19,
    word: "huit",
    phonetic: "[\u0265it]",
    type: "",
    translation: "\u865a\u97f3H adj.num.card.\uff0c adj.inv. \u516b\uff1b\u7b2c\u516b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 20,
    word: "jour",
    phonetic: "[\u0292ur]",
    type: "",
    translation: "n.m. \u5929\uff0c\u65e5\u5b50\uff1b\u592a\u9633\u5149\uff1b\u767d\u5929",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 21,
    word: "soir",
    phonetic: "[swar]",
    type: "",
    translation: "n.m. \u508d\u665a\uff0c\u9ec4\u660f\uff1b\u665a\u95f4\uff0c\u665a\u4e0a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 22,
    word: "donc",
    phonetic: "[d\u0254\u0303k]",
    type: "",
    translation: "conj. \u6240\u4ee5\uff0c\u56e0\u800c\uff0c\u56e0\u6b64\uff0c\u6545\uff1b\u90a3\u4e48\uff0c\u5f97\u5566\uff0c\u5230\u5e95\uff0c\u7a76\u7adf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 23,
    word: "habiter",
    phonetic: "[abite]",
    type: "",
    translation: "v.i. \u5c45\u4f4f\uff1bv.t. \u5c45\u4f4f\u5728\uff0c\u5b9a\u5c45\u5728\uff1b\uff08\u52a8\u7269\uff09\u6816\u606f\u5728",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 24,
    word: "plus",
    phonetic: "[plys]",
    type: "",
    translation: "[ply] adv. \u52a0\uff0c\u52a0\u4e0a\uff0c\u5916\u52a0\uff1b\u6bd4\u2026\u2026\u66f4\uff1b\u4e0d\u518d\uff0c\u518d\u6ca1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 25,
    word: "oc\u00e9an",
    phonetic: "[\u0254se\u0251\u0303]",
    type: "",
    translation: "n.m. \u6d77\u6d0b\uff1b\u5927\u6d0b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 26,
    word: "alors",
    phonetic: "[al\u0254r]",
    type: "",
    translation: "adv. \u90a3\u4e48\uff0c\u5728\u8fd9\u79cd\u60c5\u51b5\u4e0b\uff1b\u5f53\u65f6\uff0c\u90a3\u65f6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 27,
    word: "vous",
    phonetic: "[vu]",
    type: "",
    translation: "pron.pers. \u60a8\uff0c\u4f60\uff1b\u4f60\u4eec",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 28,
    word: "surpris",
    phonetic: "[syrpri, i:z]",
    type: "",
    translation: "a. \u88ab\u5f53\u573a\u6293\u4f4f\u7684\uff1b\u60ca\u6115\u7684\uff0c\u60ca\u8bb6\u7684\uff0c\u60ca\u5947\u7684 v.t. \u4e3e\u8d77\uff0c\u62ac\u8d77\uff0c\u63d0\u8d77\uff1b\u63ed\u8d77\uff1b\u64a4\u53bb\uff0c\u89e3\u9664\uff0c\u53d6\u6d88\uff1b\u4f7f\u8d77",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 29,
    word: "lever",
    phonetic: "[l\u0259ve]",
    type: "",
    translation: "\u5e8a\uff0c\u4f7f\u8d77\u8eab a. \u5c0f\u7684\uff1b\u77ee\u5c0f\u7684\uff1b\u5e7c\u5c0f\u7684\uff1b\u5fae\u91cf\u7684\uff1b\u7ec6\u5c0f\u7684\uff1b\u65e0\u5173\u7d27\u8981",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 30,
    word: "petit",
    phonetic: "[p\u0259ti, -t]",
    type: "",
    translation: "\u7684\uff1b\u5351\u9119\u7684\uff1b\u6e3a\u5c0f\u7684\uff1b\uff08\u5730\u4f4d\uff09\u4f4e\u5fae\u7684\uff1b\u53ef\u7231\u7684\uff0c\u4eb2\u7231\u7684 n.f. \u58f0\u97f3\uff0c\u55d3\u97f3\uff1b\u53d1\u8a00\u6743\uff1b\u89c1\u89e3\uff1b\uff08\u6295\u7968\u8005\u7684\uff09\u7968\uff1b[\u8bed]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 31,
    word: "voix",
    phonetic: "[vwa]",
    type: "",
    translation: "\u8bed\u6001",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 32,
    word: "elle",
    phonetic: "[\u03b5l]",
    type: "",
    translation: "pron.pers.f. \u5979\uff0c\u5b83 v.t. \u8bf4\uff0c\u8bb2\uff1b\u544a\u8bc9\uff0c\u8bb2\u8ff0\uff1b\uff08\u7528\u67d0\u4e00\u79cd\u8bed\u8a00\uff09\u8868\u8fbe\uff1b\u6717",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 33,
    word: "dire",
    phonetic: "[dir]",
    type: "",
    translation: "\u8bfb\uff0c\u5ff5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 34,
    word: "pied",
    phonetic: "[pje]",
    type: "",
    translation: "n.m. \u811a\uff0c\u8db3\uff1b\u6b65\u4f10\uff1b\u57fa\u90e8\uff1b\u82f1\u5c3a 1 of 12 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. pr\u00e9p.\uff0c n.m. \u7ecf\u8fc7\uff0c\u901a\u8fc7\uff0c\u4ece\uff1b\u8d70\u904d\uff0c\u8dd1\u904d\uff1b\u5728\u2026\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 35,
    word: "par",
    phonetic: "[par]",
    type: "",
    translation: "\u65b9\uff1a\u5728\u2026\u65f6\u5019\uff1b\u6309\u7167\uff0c\u6bcf\uff1b\u88ab\uff0c\u7531\uff1b\u7528\uff0c\u4ee5\uff0c\u901a\u8fc7\uff1b\u7531 \u4e8e\uff0c\u51fa\u4e8e\uff1b\u4ee5\u2026\u7684\u540d\u4e49\uff1b\u4ee5 v.t. \u770b\u89c1\uff1b\u89c2\u770b\uff1b\u53c2\u89c2\uff1b\u7ecf\u5386\uff1b\u78b0\u89c1\uff1b\u4f1a\u89c1\uff1b\u770b\u671b\uff1b\u7ec6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 36,
    word: "voir",
    phonetic: "[vwar]",
    type: "",
    translation: "\u770b\uff1b\u67e5\u9605\uff1b\u67e5\u770b\uff1b\u8003\u8651\uff0c\u601d\u8003\uff1b\u7406\u89e3\uff0c\u61c2\u5f97\uff0c\u660e\u767d a. \u7279\u522b\u7684\uff0c\u975e\u51e1\u7684\uff1b\u7834\u4f8b\u7684\uff1b\u5947\u7279\u7684\uff0c\u79bb\u5947\u7684\uff1b\u6770\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 37,
    word: "extraordinaire",
    phonetic: "[\u03b5kstra\u0254rdin\u03b5r]",
    type: "",
    translation: "\u7684\uff1b\u5de8\u5927\u7684 pron.relat.\uff0c conj.\uff0c adv. \u591a\u4e48\uff1b \u591a\u5c11\uff1b\u4e3a\u4ec0\u4e48\uff1b\u4ec0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 38,
    word: "que",
    phonetic: "[k\u0259]",
    type: "",
    translation: "\u4e48\uff0c \u4ec0\u4e48\u4e1c\u897f\uff0c \u4ec0\u4e48\u4e8b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 39,
    word: "tard",
    phonetic: "[tar]",
    type: "",
    translation: "adv. \u665a\uff0c\u8fdf\uff1b\u5728\u508d\u665a\uff1b\u5728\u6df1\u591c v.t. \u505a\u51fa\uff0c\u521b\u9020\uff0c\u5236\u9020\uff1b\u521b\u4f5c\uff1b\u5236\u8ba2\uff1b\u505a\uff0c\u5e72\uff0c\u8fdb\u884c\uff0c\u5b9e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 40,
    word: "faire",
    phonetic: "[f\u03b5r]",
    type: "",
    translation: "\u65bd\uff0c\u5b8c\u6210\uff1b\u4ece\u4e8b\uff0c\u5b66\u4e60\uff1b\u6574\u7406\uff0c\u6536\u62fe\uff1b\u57f9\u517b\uff1b\u4f7f\u53d8\u4e3a\uff0c\u4f7f \u6210\u4e3a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 41,
    word: "lui",
    phonetic: "[l\u0265i]",
    type: "",
    translation: "pron.pers. \u4ed6\uff0c\u5979\uff0c\u5b83",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 42,
    word: "mai",
    phonetic: "[m\u03b5]",
    type: "",
    translation: "n.m. \u4e94\u6708 pr\u00e9p. \u5728\u2026\u2026\u4e0a\u9762\uff1b\u671d\u2026\u2026\u4e0a\u9762\uff1b\u5411\u7740\uff1b\u9ad8\u4e8e\uff0c\u80dc\u4e8e\uff1b\u5173 44 s\u00fbr \u4e8e\uff1b\u6839\u636e\uff1b\u51ed v.i. \u662f\uff1b\u5728\uff0c\u5904\u5728\uff1b\u5b58\u5728\uff0c\u6709\uff1bn.m. \u5b58\u5728\uff0c\u751f\u5b58\uff1b\u5b58\u5728",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 43,
    word: "\u00eatre",
    phonetic: "[\u03b5tr]",
    type: "",
    translation: "\u7269\uff1b\u751f\u7269\uff1b\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 44,
    word: "beaucoup",
    phonetic: "[boku]",
    type: "",
    translation: "adv. \u5f88\uff0c\u5f88\u591a\uff1b\u592a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 45,
    word: "moins",
    phonetic: "[mw\u025b\u0303]",
    type: "",
    translation: "adv. \u51cf\uff1b\u5dee\uff1b\u8d1f\uff1b\u6bd4\u2026\u2026\u5c11\uff0c\u4e0d\u5982\uff1b\u6700\u5c11\uff0c\u6700\u4e0d n.m. \u6b65\uff0c\u6b65\u5b50\uff0c\u6b65\u4f10\uff0c\u6b65\u5c65\uff1b\u4e00\u6b65\u7684\u8ddd\u79bb\uff1b\u811a\u5370\uff0c\u8db3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 46,
    word: "pas",
    phonetic: "[pa]",
    type: "",
    translation: "\u8ff9\uff1b\u821e\u6b65 a. \u5927\u7684\uff0c\u9ad8\u5927\u7684\uff1b\u5e7f\u9614\u7684\uff0c\u5bbd\u5e7f\u7684\uff1b\u5f3a\u70c8\u7684\uff0c\u5267\u70c8\u7684\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 47,
    word: "grand",
    phonetic: "[gr\u0251\u0303, -d]",
    type: "",
    translation: "\u591a\u7684\uff0c\u5927\u91cf\u7684\uff1b\u957f\u5927\u7684\uff0c\u6210\u5e74\u7684\uff1b\u91cd\u8981\u7684\uff0c\u91cd\u5927\u7684\uff1b\u4f1f\u5927 \u7684\uff0c\u6770\u51fa\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 48,
    word: "regarder",
    phonetic: "[r\u0259garde]",
    type: "",
    translation: "v.t. \u770b\uff1b\u6ce8\u89c6\uff1b\u5173\u5fc3\uff1b\u6d89\u53ca\uff0c\u548c\u2026\u2026\u6709\u5173\uff1b\u5bdf\u770b zh\u00e8i 1. (\u4ee3) (\u5e38\u7528\u5728\u91cf\u8bcd\u6216\u6570\u91cf\u8bcd\u524d) ce, cette ce livre",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 49,
    word: "cette",
    phonetic: "[s\u03b5t]",
    type: "",
    translation: "\u8fd9\u672c\u4e66 2. \u53e6\u89c1 zh\u00e8\u3002 zh\u00e8 1. (\u4ee3) (\u6307\u793a\u8f83\u8fd1\u7684\u4eba\u6216\u4e8b \u7269) ce; cet ...",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 50,
    word: "r\u00e9gion",
    phonetic: "[re\u0292j\u0254\u0303]",
    type: "",
    translation: "n.f. \u5730\u533a\uff0c\u5730\u5e26\uff1b\u5927\u533a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 51,
    word: "peur",
    phonetic: "[p\u0153r]",
    type: "",
    translation: "n.f. \u6015\uff0c\u5bb3\u6015\uff1b\u754f\u60e7\uff0c\u6050\u60e7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 52,
    word: "enfant",
    phonetic: "[\u0251\u0303f\u0251\u0303]",
    type: "",
    translation: "n. \u513f\u7ae5\uff0c\u5c0f\u5b69\uff1b\u5b50\u5973",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 53,
    word: "enfin",
    phonetic: "[\u0251\u0303f\u025b\u0303]",
    type: "",
    translation: "adv. \u6700\u540e\uff0c\u7ec8\u4e8e\uff1b\u603b\u4e4b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 54,
    word: "s\u00e9rieux",
    phonetic: "[serj\u00f8]",
    type: "",
    translation: "a. \u8ba4\u771f\u7684\uff0c\u4e25\u8083\u7684\uff1b\u5e84\u91cd\u7684\uff0c\u6301\u91cd\u7684\uff1b\u4e25\u91cd\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 55,
    word: "trop",
    phonetic: "[tro]",
    type: "",
    translation: "adv. \u592a adv. \u4e5f\uff0c\u540c\u6837\uff0c\u4e00\u6837\uff1b\u8fd8\uff0c\u6b64\u5916\uff1b\u5982\u6b64\uff0c\u8fd9\u6837\uff1b\u56e0\u6b64\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 56,
    word: "aussi",
    phonetic: "[osi]",
    type: "",
    translation: "\u6240\u4ee5\uff0c\u56e0\u800c 59 tous \u5168\u4f53\u7684\uff0c\u6240\u6709\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 57,
    word: "danger",
    phonetic: "[d\u0251\u0303\u0292e]",
    type: "",
    translation: "n.m. \u5371\u9669",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 58,
    word: "papier",
    phonetic: "[papje]",
    type: "",
    translation: "n.m. \u7eb8\uff1b\u7eb8\u5f20\uff1b\u6587\u4ef6\uff0c\u6587\u4e66\uff1bpl. \u8eab\u4efd\u8bc1\u4ef6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 59,
    word: "rappeler",
    phonetic: "[raple]",
    type: "",
    translation: "v.t. \u518d\u6b21\u6253\u7535\u8bdd\u7ed9\uff08\u67d0\u4eba\uff09\uff1b\u53eb\u56de\uff1b\u53ec\u56de\uff1b\u4f7f\u60f3\u8d77",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 60,
    word: "histoire",
    phonetic: "[istwar]",
    type: "",
    translation: "n.f. \u5386\u53f2\uff1b\u5386\u53f2\u4e66\u7c4d\uff1b\u5386\u53f2\u5b66\uff1b\u6545\u4e8b\uff1b\uff08\u591a\u7528\u590d\u6570\uff09\u8c0e\u8a00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 61,
    word: "peu",
    phonetic: "[p\u00f8]",
    type: "",
    translation: "adv. \u5c11\uff0c\u4e0d\u591a\uff1b\u4e0d\u592a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 62,
    word: "savoir",
    phonetic: "[savwar]",
    type: "",
    translation: "v.t. \u4f1a\uff0c\u61c2\u5f97\uff1b\u5584\u4e8e\uff1b\u8bb0\u4f4f\uff1b\u77e5\u9053\uff1bn.m. \u77e5\u8bc6\uff0c\u5b66\u95ee",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 63,
    word: "jamais",
    phonetic: "[\u0292am\u03b5]",
    type: "",
    translation: "adv. \u4ece\u6ca1\uff0c\u4ece\u672a\uff0c\u4ece\u4e0d\uff1b\u5c06\u6765\u67d0\u65e5\uff1b\u66fe\u7ecf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 64,
    word: "seul",
    phonetic: "[s\u0153l]",
    type: "",
    translation: "a. \u5b64\u72ec\u7684\uff0c\u5b64\u5355\u7684\uff1b\u60df\u4e00\u7684\uff1b\u53ea\u6709\uff0c\u4ec5\u4ec5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 65,
    word: "celui",
    phonetic: "[s\u0259l\u0265i]",
    type: "",
    translation: "pron.d\u00e9m. \u6307\u793a\u4ee3\u8bcd\u8fd9\u4e2a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 66,
    word: "entendre",
    phonetic: "[\u0251\u0303t\u0251\u0303dr]",
    type: "",
    translation: "v.t. \u542c\u89c1\uff1b\u542c\u61c2\uff0c\u9886\u4f1a\uff1b\u60f3\uff0c\u6253\u7b97 2 of 12 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. pr\u00e9p. \u5728\u2026\u5bb6\uff0c\u5728\u2026\u90a3\u91cc\uff1b\u5230\u2026\u5bb6\uff0c\u5230\u2026\u90a3\u91cc\uff1b\u5728\u2026\u5bb6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 67,
    word: "chez",
    phonetic: "[\u222be]",
    type: "",
    translation: "\u4e61\uff1b\u5728\u2026\u5730\u65b9\uff1b\u5728\u2026\u65f6\u4ee3\uff1b\u5728\u2026\u4e2d\uff1b\u5728\u2026\u8eab\u4e0a\uff1b\u5728\u2026\u4f5c\u54c1 \u91cc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 68,
    word: "besoin",
    phonetic: "[b\u0259zw\u025b\u0303]",
    type: "",
    translation: "n.m. \u60f3\u671b\uff0c\u6b32\u671b\uff0c\u8981\u6c42\uff1b\u9700\u8981\uff0c\u5fc5\u8981\uff0c\u9700\u6c42",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 69,
    word: "d\u00e9j\u00e0",
    phonetic: "[de\u0292a]",
    type: "",
    translation: "adv. \u5df2\u7ecf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 70,
    word: "autre",
    phonetic: "[otr]",
    type: "",
    translation: "a. \u522b\u7684\uff0c\u53e6\u5916\u7684\uff1b\u4e0d\u540c\u7684\uff0c\u4e0d\u4e00\u6837\u7684\uff1b\u7b2c\u4e8c\u4e2a\uff0c\u53e6\u4e00\u4e2a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 71,
    word: "encore",
    phonetic: "[\u0251\u0303k\u0254r]",
    type: "",
    translation: "adv. \u8fd8\uff0c\u5c1a\uff0c\u4ecd\uff1b\u8fd8\u4e0d\uff0c\u8fd8\u6ca1\u6709\uff1b\u518d\uff0c\u53c8\uff0c\u91cd\u65b0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 72,
    word: "vieux",
    phonetic: "[vj\u00f8, vj\u03b5j]",
    type: "",
    translation: "a. \u5e74\u8001\u7684\uff0c\u8001\u5e74\u7684\uff1b\u5e74\u957f\u7684\uff1b\u5e74\u4ee3\u4e45\u7684\uff1b\u65e7\u7684\uff1bn. \u8001\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 73,
    word: "commencer",
    phonetic: "[k\u0254m\u0251\u0303se]",
    type: "",
    translation: "v.t. \u7740\u624b\uff0c\u5f00\u59cb\uff1b\u5f00\u5934\uff0c\u8d77\u5934\uff1bv.i. \u5f00\u59cb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 74,
    word: "pourquoi",
    phonetic: "[purkwa]",
    type: "",
    translation: "adv.\uff0c conj. \u4e3a\u4ec0\u4e48\uff0c\u4e3a\u4f55\uff1b\u539f\u56e0\uff0c\u7406\u7531\uff1b\u95ee\u9898 adj. \u7ed9\u4e88\u7684\uff0c \u9001\u7ed9\u7684\uff1b\u5df2\u5b9a\u7684\uff0c \u4e00\u5b9a\u7684\uff1b \u5df2\u77e5\u7684\uff0c \u5047",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 75,
    word: "donn\u00e9",
    phonetic: "[d\u0254ne]",
    type: "",
    translation: "\u5b9a\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 76,
    word: "comprendre",
    phonetic: "[k\u0254\u0303pr\u0251\u0303dr]",
    type: "",
    translation: "v.t. \u5305\u62ec\uff0c\u5305\u542b\uff1b\u61c2\u5f97\uff0c\u660e\u767d\uff1b\u7406\u89e3\uff1b\u610f\u8bc6\u5230",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 77,
    word: "mot",
    phonetic: "[mo]",
    type: "",
    translation: "n.m. \u8bcd\uff0c\u5b57\uff1b\u77ed\u8bed\uff1b\u4fbf\u6761\uff1b\u540d\u8a00 a. \u7b2c\u4e00\u7684\uff1b\u539f\u59cb\u7684\uff1b\u7b2c\u4e00\u4f4d\u7684\uff0c\u9996\u8981\u7684\uff1b\u521d\u6b65\u7684\uff0c\u57fa\u672c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 78,
    word: "premier",
    phonetic: "[pr\u0259mje, -\u03b5r]",
    type: "",
    translation: "\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 79,
    word: "compliqu\u00e9",
    phonetic: "[k\u0254\u0303plike]",
    type: "",
    translation: "a. \u590d\u6742\u7684\uff1b\u96be\u61c2\u7684\uff0c\u96be\u4e8e\u7406\u89e3\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 80,
    word: "comment",
    phonetic: "[k\u0254m\u0251\u0303]",
    type: "",
    translation: "adv. \u5982\u4f55\uff0c \u600e\u4e48\uff0c \u600e\u6837\uff1b\u4e3a\u4f55\uff0c \u4e3a\u4ec0\u4e48",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 81,
    word: "ciel",
    phonetic: "[sj\u03b5l]",
    type: "",
    translation: "n.m. \u5929\uff0c\u5929\u7a7a\uff1b\u84dd\u5929",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 82,
    word: "oui",
    phonetic: "[wi]",
    type: "",
    translation: "adv. \u662f\uff0c\u662f\u7684\uff0c\u5bf9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 83,
    word: "rire",
    phonetic: "[rir]",
    type: "",
    translation: "v.i. \u7b11\uff0c\u53d1\u7b11\uff1b\u73a9\u4e50\uff1b\u5f00\u73a9\u7b11\uff1bn.m. \u7b11 v.t. \u62ff\uff0c\u53d6\uff0c\u6293\uff1b\u643a\u5e26\uff1b\u642d\u4e58\uff1b\u5e26\u8d70\uff0c\u63a5\u8d70\uff1b\u5403\uff0c\u559d\uff0c\u670d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 84,
    word: "prendre",
    phonetic: "[pr\u0251\u0303dr]",
    type: "",
    translation: "\u7528\uff1b\u8bb0\u5f55\uff1b\u62cd\u6444\uff1b\u63a5\u53d7\uff1b\u4e70\uff1b\u5360\u7528\uff0c\u82b1\u8d39\uff1b\u653b\u5360\uff0c\u593a\u53d6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 85,
    word: "toi",
    phonetic: "[twa]",
    type: "",
    translation: "pron.pers. \u4f60 v.i. \u6765\uff0c\u6765\u5230\uff1b\u51fa\u73b0\uff0c\u4ea7\u751f\uff1b\u53d1\u751f\uff0c\u7a81\u7136\u6765\u4e34\uff1b\u6765\u81ea\uff1b\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 86,
    word: "venir",
    phonetic: "[v(\u0259)nir]",
    type: "",
    translation: "\u81ea\uff0c\u4ea7\u81ea\uff1b\u6e90\u4e8e\uff1b\u4ece\u2026\u2026\u4f20\u4e0b\u6765",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 87,
    word: "loin",
    phonetic: "[lw\u025b\u0303]",
    type: "",
    translation: "adv. \u8fdc\uff0c\u9065\u8fdc\uff1b\u4e45\u8fdc\uff0c\u957f\u4e45 v.i. \u51fa\u53bb\uff1b\u9732\u51fa\uff1b\u6563\u53d1\u51fa\uff1b\u6d41\u51fa\uff1b\u51fa\u7248\uff1b\u4e0a\u6620\uff1bv.t. \u62ff",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 88,
    word: "sortir",
    phonetic: "[s\u0254rtir]",
    type: "",
    translation: "\u51fa\uff1b\u4f7f\u6446\u8131\uff1b\u5e26\u2026\u2026\u5916\u51fa\uff1b\u51fa\u7248\uff0c\u53d1\u8868",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 89,
    word: "son",
    phonetic: "[s\u0254\u0303]",
    type: "",
    translation: "n.m. \u97f3\uff0c\u58f0\u97f3 / adj. \u4ed6\uff08\u5979\u3001\u5b83\uff09\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 90,
    word: "combien",
    phonetic: "[k\u0254\u0303bj\u025b\u0303]",
    type: "",
    translation: "adv. \u7b2c\u51e0\uff1b\u51e0\u53f7\uff1b\u591a\u5c11\uff1b\u591a\u4e48",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 91,
    word: "plan\u00e8te",
    phonetic: "[plan\u03b5t]",
    type: "",
    translation: "n.f. \u884c\u661f adj. \u957f\u7684\uff0c\u8fdc\u7684\uff1b\u957f\u4e45\u7684\uff0c\u4e45\u8fdc\u7684 n.m.\u957f\uff0c\u957f\u5ea6 adv.\u8bb8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 92,
    word: "longue",
    phonetic: "[l\u0254\u0303g]",
    type: "",
    translation: "\u591a\uff0c\u5f88\u591a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 93,
    word: "silence",
    phonetic: "[sil\u0251\u0303s]",
    type: "",
    translation: "n.m. \u5bc2\u9759\uff0c\u6c89\u9ed8\uff1b\u4e0d\u8054\u7cfb\uff0c\u4e0d\u5199\u4fe1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 94,
    word: "donner",
    phonetic: "[d\u0254ne]",
    type: "",
    translation: "v.t. \u7ed9\u4e88\uff1b\u8d60\u7ed9\uff1b\u732e\u51fa\uff1b\u4ed8\u51fa\uff1b\u4ea4\u7ed9\uff0c\u4ea4\u4ed8\uff1b\u63d0\u4f9b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 95,
    word: "nuit",
    phonetic: "[n\u0265i]",
    type: "",
    translation: "n.f. \u591c\uff0c\u591c\u665a\uff0c\u591c\u95f4\uff1b\u6f06\u9ed1\uff0c\u9ed1\u6697 v.t. \u4e3a\u2026\u2026\u670d\u52a1\uff0c\u4e3a\u2026\u2026\u6548\u529b\uff1b\u670d\u4f8d\uff1b\u4f3a\u5019\u5403\u996d\uff1b\u63a5\u5f85\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 96,
    word: "servir",
    phonetic: "[s\u03b5rvir]",
    type: "",
    translation: "\u7aef\u4e0a\uff08\u996d\u83dc\uff09\uff0c\u4f9b\u5e94",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 97,
    word: "maison",
    phonetic: "[m\u03b5z\u0254\u0303]",
    type: "",
    translation: "n.f.\uff08\u72ec\u6237\uff09\u4f4f\u5b85\uff1b\u5bb6\uff1b\u9662\uff0c\u6240\uff0c\u9986\uff1b\u5546\u884c\uff0c\u5546\u5e97 v.i. \u8d70\uff0c\u53bb\uff1b\u901a\u5411\uff1b\u5e72\uff0c\u884c\u52a8\uff1b\u8868\u73b0\uff1b\u5904\u4e8e\u2026\u7684\u5065\u5eb7\u72b6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 98,
    word: "aller",
    phonetic: "[ale]",
    type: "",
    translation: "\u51b5\uff1b\u9002\u5408\uff0c\u76f8\u914d\uff1b\u8fdb\u884c\uff1bn.m. \u53bb\uff1b\u53bb\u7a0b\uff1b\u53bb\u7a0b\u8f66\u7968",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 99,
    word: "important",
    phonetic: "[\u025b\u0303p\u0254rt\u0251\u0303]",
    type: "",
    translation: "a. \u91cd\u8981\u7684\uff0c\u91cd\u5927\u7684\uff1b\u5927\u91cf\u7684\uff0c\u53ef\u89c2\u7684 a. \u7c97\u58ee\u7684\uff1b\u80d6\u7684\uff1b\u539a\u7684\uff1b\u5927\u7684\uff1b\u91cd\u5927\u7684\uff1b\u4e25\u91cd\u7684\uff1bn.m.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 100,
    word: "gros",
    phonetic: "[gro, -s]",
    type: "",
    translation: "\u6279\u53d1 n.m. \u540d\u5b57\uff1b\u59d3\u540d\uff1b\u59d3\u6c0f\uff1b\u540d\u4e49\uff1b\u540d\u79f0\uff1b\u540d\u8a89\uff0c\u540d\u58f0\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 101,
    word: "nom",
    phonetic: "[n\u0254\u0303]",
    type: "",
    translation: "[\u8bed]\u540d\u8bcd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 102,
    word: "num\u00e9ro",
    phonetic: "[nymero]",
    type: "",
    translation: "n.m. \u53f7\u6570\uff0c\u53f7\u7801\uff1b\uff08\u671f\u520a\u7684\uff09\u671f\uff0c\u53f7\uff1b\u8282\u76ee 3 of 12 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 103,
    word: "exemple",
    phonetic: "[\u03b5gz\u0251\u0303pl]",
    type: "",
    translation: "n.m. \u6a21\u8303\uff0c\u5178\u8303\uff0c\u699c\u6837\uff1b\u6559\u8bad\uff1b\u5b9e\u4f8b\uff1b\u6837\u672c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 104,
    word: "raison",
    phonetic: "[r\u03b5z\u0254\u0303]",
    type: "",
    translation: "n.f. \u539f\u56e0\uff0c\u7406\u7531\uff1b\u7406\u667a\uff0c\u7406\u6027\uff1b\u9053\u7406\uff0c\u60c5\u7406\uff1b\u660e\u667a\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 105,
    word: "croire",
    phonetic: "[krwar]",
    type: "",
    translation: "v.t. \u76f8\u4fe1\uff1b\u4fe1\u4efb\uff1b\u8ba4\u4e3a\uff1b\u89c9\u5f97",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 106,
    word: "cet",
    phonetic: "[s\u03b5t]",
    type: "",
    translation: "\u8fd9\uff0c \u8fd9\u4e9b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 107,
    word: "monde",
    phonetic: "[m\u0254\u0303d]",
    type: "",
    translation: "n.m. \u4e16\u754c\uff1b\u4eba\u95f4\uff1b\u4eba\u4eec\uff1b\u9636\u5c42\uff1b\u754c\uff1b\u4e0a\u6d41\u793e\u4f1a\uff0c\u793e\u4ea4\u754c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 108,
    word: "aimer",
    phonetic: "[\u03b5me]",
    type: "",
    translation: "ou [eme] v.t. \u7231\uff0c\u70ed\u7231\uff1b\u7231\u604b\uff1b\u7231\u597d\uff0c\u559c\u6b22 adj.poss.\uff0c pron.pers. \u4ed6\u4eec\u7684\uff0c \u5979\u4eec\u7684\uff0c \u5b83\u4eec\u7684\uff1b\u4ed6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 109,
    word: "leur",
    phonetic: "[l\u0153r]",
    type: "",
    translation: "\u4eec\uff0c \u5979\u4eec\uff0c \u5b83\u4eec[\u7528\u4f5c\u95f4\u63a5\u5bbe\u8bed]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 110,
    word: "seulement",
    phonetic: "[s\u0153lm\u0251\u0303]",
    type: "",
    translation: "adv. \u53ea\uff0c\u4ec5\u4ec5\uff1b\u521a\u521a\uff1b\u4e0d\u8fc7 adj. \u8bf4\u5b9a\u7684\uff0c\u8bf4\u59a5\u7684\uff0c\u8bf4\u597d\u7684\uff1b\u5916\u53f7\u53eb\u2026\u7684\uff0c\u7ef0\u53f7\u53eb\u2026",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 111,
    word: "dit",
    phonetic: "[di, -t]",
    type: "",
    translation: "\u7684\uff1b\u4e0a\u8ff0\u7684 a. \u7f8e\u4e3d\u7684\uff0c\u6f02\u4eae\u7684\uff1b\u4f18\u7f8e\u7684\uff1b\u6674\u6717\u7684\uff1b\u5353\u8d8a\u7684\uff0c\u4f18\u79c0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 112,
    word: "beau",
    phonetic: "[bo, b\u03b5l]",
    type: "",
    translation: "\u7684\uff1b\u9ad8\u5c1a\u7684\uff1b\u9002\u5b9c\u7684\uff1b\u975e\u5e38\u597d\u7684\uff1b\u5927\u91cf\u7684\uff0c\u91cd\u5927\u7684 n.f. \u8537\u8587\u82b1\uff0c\u73ab\u7470\u82b1\uff1b\u5706\u82b1\u7a97\uff1ba. \u73ab\u7470\u8272\u7684\uff0c\u7c89\u7ea2\u8272\u7684\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 113,
    word: "rose",
    phonetic: "[roz]",
    type: "",
    translation: "\u8272\u60c5\u7684\uff1bn.m. \u73ab\u7470\u7ea2\uff0c\u7c89\u7ea2\u8272",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 114,
    word: "imaginer",
    phonetic: "[ima\u0292ine]",
    type: "",
    translation: "v.t. \u60f3\u8c61\uff0c\u8bbe\u60f3\uff1b\u53d1\u73b0\uff0c\u60f3\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 115,
    word: "vouloir",
    phonetic: "[vulwar]",
    type: "",
    translation: "v.t. \u613f\u610f\uff0c\u5e0c\u671b\uff1b\u60f3\u8981\uff1b\u9700\u8981\uff1b\u8981\u4ef7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 116,
    word: "nous",
    phonetic: "[nu]",
    type: "",
    translation: "pron.pers. \u6211\u4eec\uff0c\u54b1\u4eec",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 117,
    word: "aim\u00e9",
    phonetic: "[\u03b5me]",
    type: "",
    translation: "\u88ab\u7231\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 118,
    word: "air",
    phonetic: "[\u03b5r]",
    type: "",
    translation: "n.m. \u5927\u6c14\uff0c\u7a7a\u6c14\uff1b\u7a7a\u4e2d\uff0c\u5929\u7a7a\uff1b\u6837\u5b50\uff0c\u795e\u8272",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 119,
    word: "car",
    phonetic: "[kar]",
    type: "",
    translation: "conj. \u56e0\u4e3a\uff1bn.m. \u65c5\u6e38\u8f66",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 120,
    word: "souvenir",
    phonetic: "[suvnir]",
    type: "",
    translation: "n.m. \u8bb0\u5fc6\uff0c\u56de\u5fc6\uff1b\u7eaa\u5ff5\u7269\uff0c\u7eaa\u5ff5\u54c1\uff1bpl. \u56de\u5fc6\u5f55",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 121,
    word: "oublier",
    phonetic: "[ublije]",
    type: "",
    translation: "v.t. \u5fd8\u8bb0\uff1b\u5ffd\u7565\uff0c\u758f\u5ffd\uff0c\u758f\u6f0f\uff1b\u9057\u5fd8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 122,
    word: "devenir",
    phonetic: "[d\u0259vnir]",
    type: "",
    translation: "v.i. \u53d8\u6210\uff0c\u53d8\u5f97\uff0c\u6210\u4e3a\uff1b\u6709\u2026\u2026\u7684\u7ed3\u679c\uff1b\u5904\u4e8e\u2026\u2026\u72b6\u51b5 n.f. \u989c\u8272\uff1b\u5f69\u8272\uff1b\u989c\u6599\uff1b\u67d3\u6599\uff1b\u8272\u5f69\uff1b\u8138\u8272\uff1b\u80a4\u8272\uff1b\u653f\u6cbb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 123,
    word: "couleur",
    phonetic: "[kul\u0153r]",
    type: "",
    translation: "\u8272\u5f69 v.t. \u5f00\uff0c\u6253\u5f00\uff1b\u5f00\u8f9f\uff1b\u5f00\u653e\uff1b\u5f00\u529e\uff1bv.i. \u5f00\u542f\uff1b\u5f00\u5f20\uff1b\u5f00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 124,
    word: "ouvrir",
    phonetic: "[uvrir]",
    type: "",
    translation: "\u95e8\u8425\u4e1a a. \u53ef\u80fd\u7684\uff0c\u53ef\u80fd\u5b58\u5728\u7684\uff0c\u53ef\u80fd\u53d1\u751f\u7684\uff1b\u8fd8\u53ef\u4ee5\u7684\uff1b\u53ef\u4ee5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 125,
    word: "possible",
    phonetic: "[p\u0254sibl]",
    type: "",
    translation: "\u63a5\u53d7\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 126,
    word: "explication",
    phonetic: "[\u03b5ksplikasj\u0254\u0303]",
    type: "",
    translation: "n.f. \u8bf4\u660e\uff0c\u89e3\u91ca\uff1b\u8bf4\u660e\u539f\u56e0\uff0c\u89e3\u91ca\u7406\u7531",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 127,
    word: "malheureusement",
    phonetic: "[mal\u00f8r\u00f8zm\u0251\u0303]",
    type: "",
    translation: "adv. \u4e0d\u5e78\u5730\uff0c\u53ef\u60dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 128,
    word: "chaque",
    phonetic: "[\u222bak]",
    type: "",
    translation: "a.ind\u00e9f.(\u6574\u4f53\u4e2d\u7684)\u6bcf\u4e2a, \u5404\u4e2a;\u6bcf\u4e00\u4e2a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 129,
    word: "voyager",
    phonetic: "[vwaja\u0292e]",
    type: "",
    translation: "v.i. \u65c5\u884c\uff1b\u65c5\u6e38\uff0c\u6e38\u5386\uff1b\u88ab\u8fd0\u9001\uff0c\u88ab\u8fd0\u8f93[\u6307\u7269\u6216\u7272\u53e3]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 130,
    word: "manger",
    phonetic: "[m\u0251\u0303\u0292e]",
    type: "",
    translation: "v.t. \u5403\uff1b\u5403\u996d\uff0c\u5403\u4e1c\u897f\uff1b\u86c0\u98df\uff1b\u8150\u8680",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 131,
    word: "arbre",
    phonetic: "[arbr]",
    type: "",
    translation: "n.m. \u6811\uff0c\u6811\u6728 v.t. \u653e\uff0c\u7f6e\uff0c\u6446\uff1b\u9001\u5165\uff0c\u4f7f\u8fdb\u5165\uff1b\u5b89\u7f6e\uff1b\u6234\uff0c\u7a7f\uff1b\u914d\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 132,
    word: "mettre",
    phonetic: "[m\u03b5tr]",
    type: "",
    translation: "\u6dfb\uff0c\u52a0\uff0c\u8865\uff1b\u4f7f\u5904\u4e8e\u2026\u2026\u72b6\u6001\uff1b\u8bbe\u7f6e\uff0c\u5b89\u88c5\uff1b\u82b1\u8d39\uff08\u65f6 \u95f4\uff0c\u91d1\u94b1\uff09 pr\u00e9p. [\u8868\u65f6\u95f4]\u5728\u2026\u2026\u4ee5\u524d\uff1b[\u8868\u7a7a\u95f4]\u5728\u2026\u2026\u524d\u9762\uff1b[\u8868\u6b21",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 133,
    word: "avant",
    phonetic: "[av\u0251\u0303]",
    type: "",
    translation: "\u5e8f\u3001\u7b49\u7ea7]\u5728\u2026\u2026\u4e4b\u4e0a\uff0c\u5728\u2026\u2026\u4e4b\u524d\uff1b\u4f18\u5148\uff1bn.m. \u524d\u90e8\uff1b [\u4f53]\u524d\u950b\uff1b[\u519b]\u524d\u7ebf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 134,
    word: "effet",
    phonetic: "[ef\u03b5]",
    type: "",
    translation: "n.m. \u6548\u679c\uff0c\u4f5c\u7528\uff1b\u7ed3\u679c\uff1b\u6548\u529b\uff1b\u5f71\u54cd\uff1b[\u7269\uff0c\u751f]\u6548\u5e94",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 135,
    word: "bon",
    phonetic: "[b\u0254\u0303, b\u0254n]",
    type: "",
    translation: "a. \u597d\u7684\uff1b\u6070\u5f53\u7684\uff1b\u6b63\u786e\u7684\uff1b\u4f18\u79c0\u7684\uff1b\u7f8e\u597d\u7684 a. \u4f4e\u52a3\u7684\uff0c\u574f\u7684\uff1b\u4e0d\u9002\u5f53\u7684\uff1b\u4e0d\u7965\u7684\uff1b\u6709\u5bb3\u7684\uff0c\u5371\u9669",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 136,
    word: "mauvais",
    phonetic: "[m\u0254v\u03b5, -z]",
    type: "",
    translation: "\u7684\uff1b\u6076\u7684\uff0c\u6076\u6bd2\u7684\uff0c\u6076\u610f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 137,
    word: "soleil",
    phonetic: "[s\u0254l\u03b5j]",
    type: "",
    translation: "n.m. \u592a\u9633\uff1b\u9633\u5149\uff1b\u6674\u5929",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 138,
    word: "laisser",
    phonetic: "[lese]",
    type: "",
    translation: "ou [l\u03b5se] v.t. \u7559\uff0c\u4fdd\u7559\uff1b\u4e0d\u7ba1\uff1b\u7559\u7ed9\uff1b\u4ea4\u7ed9\uff1b\u4e22\u4e0b\uff1b\u9057\u7559\uff1b\u4efb\u51ed 4 of 12 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. a. \u53ef\u6015\u7684\uff0c\u9a87\u4eba\u7684\uff1b\u4ee4\u4eba\u8ba8\u538c\u7684\uff0c\u53eb\u4eba\u96be\u53d7\u7684\uff1b\u731b\u70c8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 139,
    word: "terrible",
    phonetic: "[teribl]",
    type: "",
    translation: "ou [t\u03b5ribl] \u7684\uff1b\u975e\u5e38\u591a\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 140,
    word: "toilette",
    phonetic: "[twal\u03b5t]",
    type: "",
    translation: "n.f. \u68b3\u6d17\uff1b\u6253\u626e\uff1b\u68b3\u5986\u53f0\uff1bn.f. pl. \u5395\u6240\uff0c\u536b\u751f\u95f4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 141,
    word: "matin",
    phonetic: "[mat\u025b\u0303]",
    type: "",
    translation: "n.m. \u65e9\u6668\uff1b\u4e0a\u5348\uff0c\u4e0a\u534a\u5929",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 142,
    word: "r\u00e9gulier",
    phonetic: "[regylje, -\u03b5r]",
    type: "",
    translation: "a. \u6709\u89c4\u5f8b\u7684\uff1b\u89c4\u77e9\u7684\uff1b\u5b9a\u671f\u7684\uff1b\u7ecf\u5e38\u7684\uff1b\u5408\u6cd5\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 143,
    word: "travail",
    phonetic: "[travaj]",
    type: "",
    translation: "n.m. \u52b3\u52a8\uff0c\u5de5\u4f5c\uff1b\u6d3b\u513f\uff1b\u4efb\u52a1\uff1b\u804c\u4e1a\uff1b\u5e72\u6d3b\uff1b\u5de5\u4f5c\u5730\u70b9 v.i. \u8fdb\u5165\uff1b\u89e6\u53ca\uff0c\u6d89\u53ca\uff1b\u53c2\u52a0\uff0c\u53c2\u4e0e\uff1b\u5305\u62ec\u5728\uff1bv.t. \u642c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 144,
    word: "entrer",
    phonetic: "[\u0251\u0303tre]",
    type: "",
    translation: "\u5165\uff0c\u8fd0\u5165",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 145,
    word: "pouvoir",
    phonetic: "[puvwar]",
    type: "",
    translation: "v.t. \u80fd\u591f\uff1b\u53ef\u4ee5\uff1b\u53ef\u80fd\uff1bn.m. \u80fd\u529b\uff1b\u6743\u5a01\uff1b\u6743\u529b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 146,
    word: "toujours",
    phonetic: "[tu\u0292ur]",
    type: "",
    translation: "adv. \u6c38\u8fdc\uff0c\u4e00\u76f4\uff1b\u603b\u662f\uff1b\u59cb\u7ec8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 147,
    word: "conna\u00eetre",
    phonetic: "[k\u0254n\u03b5tr]",
    type: "",
    translation: "v.t. \u77e5\u9053\uff0c\u8ba4\u5f97\uff1b\u61c2\u5f97\uff0c\u719f\u6089\uff1b\u8ba4\u8bc6\uff1b\u4e86\u89e3\uff1b\u4f53\u9a8c\uff0c\u7ecf\u5386",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 148,
    word: "trois",
    phonetic: "[trwa]",
    type: "",
    translation: "adj.num.card.\uff0c adj.inv. \u4e09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 149,
    word: "ton",
    phonetic: "[t\u0254\u0303]",
    type: "",
    translation: "n.m. \u97f3\u8c03\uff0c\u58f0\u8c03\uff1badj. \u4f60\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 150,
    word: "ami",
    phonetic: "[ami]",
    type: "",
    translation: "n. \u670b\u53cb\uff1b\u53cb\u597d\u8005\uff0c\u540c\u60c5\u8005\uff1b\u60c5\u4eba a. \u5355\u4e00\u7684\uff0c\u5355\u7eaf\u7684\uff1b\u6613\u61c2\u7684\uff0c\u7b80\u5355\u7684\uff1b\u7b80\u6613\u7684\uff1b\u7b80\u6734",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 151,
    word: "simple",
    phonetic: "[s\u025b\u0303pl]",
    type: "",
    translation: "\u7684\uff1b\u666e\u901a\u7684\uff1b\u5929\u771f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 152,
    word: "route",
    phonetic: "[rut]",
    type: "",
    translation: "n.f. \u9053\u8def\uff0c\u516c\u8def\uff1b\u516c\u8def\u8fd0\u8f93\uff1b\u8def\u7a0b\uff0c\u65c5\u9014",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 153,
    word: "homme",
    phonetic: "[\u0254m]",
    type: "",
    translation: "n.m. \u4eba\uff1b\u4eba\u7c7b\uff1b\u7537\u4eba\uff1b\u7537\u5b50\u6c49",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 154,
    word: "bonjour",
    phonetic: "[b\u0254\u0303\u0292ur]",
    type: "",
    translation: "n.m. \u65e9\u5b89\uff01\u65e5\u5b89\uff01\u4f60\u597d\uff01",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 155,
    word: "jardin",
    phonetic: "[\u0292ard\u025b\u0303]",
    type: "",
    translation: "n.m. \u56ed\u5b50\uff0c\u83dc\u56ed\uff0c\u82b1\u56ed",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 156,
    word: "fleur",
    phonetic: "[fl\u0153r]",
    type: "",
    translation: "n.f. \u82b1\uff1b\u6709\u82b1\u690d\u7269\uff1b\u82b1\u7684\u56fe\u6848\uff1b\u82b1\u72b6\u7269\uff1b\u7cbe\u534e\uff0c\u7cbe\u7cb9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 157,
    word: "vraiment",
    phonetic: "[vr\u03b5m\u0251\u0303]",
    type: "",
    translation: "adv. \u771f\u6b63\u5730\uff0c\u786e\u5b9e\u5730\uff0c\u5b9e\u5728\u5730 a. \u5bcc\u7684\uff0c\u6709\u94b1\u7684\uff1b\u5145\u8db3\u7684\uff1b\u4e30\u5bcc\u7684\uff0c\u5bcc\u9976\u7684\uff1bn. \u5bcc\u4eba\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 158,
    word: "riche",
    phonetic: "[ri\u222b]",
    type: "",
    translation: "\u6709\u94b1\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 159,
    word: "unique",
    phonetic: "[ynik]",
    type: "",
    translation: "a. \u60df\u4e00\u7684\uff1b\u72ec\u7279\u7684\uff0c\u65e0\u4e0e\u4f26\u6bd4\u7684\uff1b\u5c11\u6709\u7684\uff0c\u5c11\u89c1\u7684 v.i. \u8d70\uff0c\u884c\u8d70\uff1b\u8e0f\uff0c\u8e29\uff1b\uff08\u8f66\u8f86\u3001\u8239\u7684\uff09\u884c\u9a76\uff1b\u8fd0\u884c\uff0c\u8fd0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 160,
    word: "marcher",
    phonetic: "[mar\u222be]",
    type: "",
    translation: "\u8f6c\uff1b\u53d6\u5f97\u8fdb\u5c55",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 161,
    word: "penser",
    phonetic: "[p\u0251\u0303se]",
    type: "",
    translation: "v.i. \u60f3\uff0c\u601d\u7d22\uff0c\u601d\u8003",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 162,
    word: "geste",
    phonetic: "[\u0292\u03b5st]",
    type: "",
    translation: "n.m. \u624b\u52bf\uff0c\u59ff\u52bf\uff1b\u52a8\u4f5c\uff1b\u6177\u6168\u7684\u884c\u4e3a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 163,
    word: "chercher",
    phonetic: "[\u222b\u03b5r\u222be]",
    type: "",
    translation: "v.t. \u5bfb\u627e\uff1b\u5bfb\u6c42\uff0c\u8c0b\u6c42\uff1b\u62db\u60f9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 164,
    word: "heure",
    phonetic: "[\u0153r]",
    type: "",
    translation: "n.f. \u5c0f\u65f6\uff1b\u65f6\u95f4\uff1b\u70b9\u949f\uff1b\u949f\u70b9\uff1b\u65f6\u523b\uff0c\u65f6\u671f v.i. \u8dcc\u5012\uff1b\u5012\u584c\uff1b\u8dcc\u843d\uff1b\u8131\u843d\uff1b\u964d\u843d\uff1b\u5782\u4e0b\uff1b\u5012\u4e0b\uff1b\u9635",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 165,
    word: "tomber",
    phonetic: "[t\u0254\u0303be]",
    type: "",
    translation: "\u4ea1\uff1b\u5012\u6bd9\uff1b\u4e0b\u53f0\uff1b\u51cf\u5f31\uff1b\u8dcc\u5165",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 166,
    word: "lune",
    phonetic: "[lyn]",
    type: "",
    translation: "n.f. \u6708\u4eae\uff0c\u6708\u7403",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 167,
    word: "part",
    phonetic: "[par]",
    type: "",
    translation: "n.f. \u4efd\uff0c\u4efd\u989d\uff1b\u90e8\u5206\uff1b\u80a1\u4efd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 168,
    word: "beaut\u00e9",
    phonetic: "[bote]",
    type: "",
    translation: "n.f. \u7f8e\uff0c\u4f18\u7f8e\uff0c\u7f8e\u4e3d\uff1b\u9ad8\u5c1a\uff0c\u5d07\u9ad8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 169,
    word: "bras",
    phonetic: "[bra, br\u0251]",
    type: "",
    translation: "n.m. \u81c2\uff0c\u80f3\u818a\uff1b\u81c2\u72b6\u7269\uff1b\u6276\u624b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 170,
    word: "vent",
    phonetic: "[v\u0251\u0303]",
    type: "",
    translation: "n.m. \u98ce\uff1b\u7a7a\u6c14\uff0c\u6c14\u6d41\uff1b\u8d8b\u52bf\uff1b\u98ce\u6c14",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 171,
    word: "lampe",
    phonetic: "[l\u0251\u0303p]",
    type: "",
    translation: "n.f. \u706f\uff1b\u7167\u660e\u5668\u5177\uff1b\uff08\u7535\uff09\u706f\u6ce1 n.m. \u51fb\uff0c\u6253\uff0c\u6572\uff0c\u649e\uff1b\u4e00\u4e3e\uff0c\u4e00\u7740\uff0c\u4e00\u4e0b\uff1b\u6572\u6253\u58f0\uff0c\u649e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 172,
    word: "coup",
    phonetic: "[ku]",
    type: "",
    translation: "\u51fb\u58f0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 173,
    word: "c\u00f4t\u00e9",
    phonetic: "[kote]",
    type: "",
    translation: "n.m. \u65c1\uff0c\u4fa7\uff1b\u65b9\u5411\uff1b\u65b9\u9762\uff1b\u808b\uff0c\u80f8\u4fa7\uff0c\u4f53\u4fa7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 174,
    word: "mur",
    phonetic: "[myr]",
    type: "",
    translation: "n.m. \u5899\uff0c\u58c1\uff1b\u969c\u788d\uff1b\u5ced\u58c1 a. \u65b0\u51fa\u73b0\u7684\uff0c\u65b0\u521b\u7684\uff1b\u65b0\u7684\uff0c\u65b0\u8fd1\u7684\uff1b\u65b0\u5947\u7684\uff0c\u524d\u6240\u672a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 175,
    word: "nouveau",
    phonetic: "[nuvo, -\u03b5l]",
    type: "",
    translation: "\u95fb\u7684\uff1b\u4e0d\u719f\u6089\u7684\uff1b\u65e0\u7ecf\u9a8c\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 176,
    word: "attendre",
    phonetic: "[at\u0251\u0303dr]",
    type: "",
    translation: "v.t. \u7b49\uff0c\u7b49\u5019\uff1b\u7b49\u5f85\uff1b\u671f\u671b\uff0c\u671f\u5f85",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 177,
    word: "vingt",
    phonetic: "[v\u025b\u0303]",
    type: "",
    translation: "adj.num.card. \u4e8c\u5341 5 of 12 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. a. \u7ef7\u7d27\u7684\uff0c\u7d27\u8d34\u7684\uff1b\u5bc6\u96c6\u7684\uff1b\u7cbe\u70bc\u7684\uff1b\u7d27\u51d1\u7684\uff1b\uff08\u65f6\u95f4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 178,
    word: "serr\u00e9",
    phonetic: "[sere]",
    type: "",
    translation: "ou [s\u03b5re] \u7b49\uff09\u7d27\u7684 a. \u6b63\u4e49\u7684\uff0c\u516c\u9053\u7684\uff1b\u516c\u6b63\u7684\uff0c\u516c\u5e73\u7684\uff1b\u6b63\u786e\u7684\uff0c\u6b63\u5f53",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 179,
    word: "juste",
    phonetic: "[\u0292yst]",
    type: "",
    translation: "\u7684\uff1b\u51c6\u786e\u7684\uff0c\u7cbe\u786e\u7684\uff1b\u5408\u7406\u7684\uff1b\u51e0\u4e4e\u4e0d\u591f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 180,
    word: "temps",
    phonetic: "[t\u0251\u0303]",
    type: "",
    translation: "n.m. \u65f6\u95f4\uff1b\u9636\u6bb5\uff1b\u65f6\u4ee3\uff0c\u65f6\u671f\uff1b\u65f6\u5019\uff1b[\u8bed]\u65f6\u6001\uff1b\u5929\u6c14",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 181,
    word: "machine",
    phonetic: "[ma\u222bin]",
    type: "",
    translation: "n.f. \u673a\u68b0\uff0c\u673a\u5668\uff1b\u673a\u68b0\u8f66\u8f86\uff1b\u673a\u6784\uff0c\u673a\u5173 v.i. \u56de\u6765\uff0c\u56de\u5230\uff1b\u56de\u5bb6\uff1b\u6062\u590d\uff1b\u8fdb\u5165\uff1bv.t. \u6536\u8fdb\uff1b\u4f7f\u8fdb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 182,
    word: "rentrer",
    phonetic: "[r\u0251\u0303tre]",
    type: "",
    translation: "\u5165\uff1b\u7f29\u56de v.i. \u7ecf\u8fc7\uff1b\u901a\u8fc7\uff1b\u5230\u2026\u2026\u53bb\uff1b\u8f6c\u5165\uff1b\u4f20\u5165\uff0c\u4f20\u9001\uff1b\u6d41\u901d\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 183,
    word: "passer",
    phonetic: "[pase]",
    type: "",
    translation: "\u653e\u6620\uff0c\u4e0a\u6620\uff1bv.t. \u7a7f\u8fc7\uff0c\u901a\u8fc7\uff1b\u8d85\u51fa\uff0c\u8d85\u8d8a\uff1b\u5ea6\u8fc7\uff1b\u8df3 \u8fc7\uff0c\u9057\u6f0f\uff1b\u4f20\u9012\uff1b\u4f20\u67d3\uff1b\u653e\u6620",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 184,
    word: "musique",
    phonetic: "[myzik]",
    type: "",
    translation: "n.f. \u97f3\u4e50\uff1b\u4e50\u66f2\uff1b\u97f3\u4e50\u6027\uff0c\u548c\u8c10\uff0c\u60a6\u8033 adv. \u66f4\u597d\u5730\uff0c\u8f83\u597d\u5730\uff1b\u66f4\u52a0\uff1b\u6700\u597d\u5730\uff1bn.m. \u6700\u4f73\uff0c\u6700",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 185,
    word: "mieux",
    phonetic: "[mj\u00f8]",
    type: "",
    translation: "\u597d\uff1b\u597d\u8f6c\uff0c\u66f4\u597d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 186,
    word: "gens",
    phonetic: "[\u0292\u0251\u0303]",
    type: "",
    translation: "n.m.\uff0c n.f. pl. \u4eba\u4eec\uff1b\u4eba a. [\u653e\u5728\u540d\u8bcd\u524d]\u76f8\u540c\u7684\uff0c\u540c\u6837\u7684\uff1b[\u653e\u5728\u540d\u8bcd\u540e]\u672c\u8eab\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 187,
    word: "m\u00eame",
    phonetic: "[m\u03b5m]",
    type: "",
    translation: "[\u653e\u5728\u4eba\u79f0\u4ee3\u8bcd\u540e]\u81ea\u5df1\uff1badv. \u751a\u81f3\uff0c\u5373\u4f7f\uff1b\u6b63\u662f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 188,
    word: "plaisir",
    phonetic: "[pl\u03b5zir]",
    type: "",
    translation: "n.m. \u6109\u5feb\uff0c\u9ad8\u5174\uff0c\u5feb\u4e50\uff1b\u4e50\u8da3\uff1b\u5a31\u4e50 n.m. \u5468\u56f4\uff0c\u5468\u957f\uff1b\u73af\u7ed5\uff0c\u73af\u884c\uff1b\u6563\u6b65\uff1b\u8f6c\u52a8\uff0c\u65cb\u8f6c\uff1b\u65cb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 189,
    word: "tour",
    phonetic: "[tur]",
    type: "",
    translation: "\u8f6c\u7684\u4e00\u5468\uff0c\u4e00\u5708\uff1b\u5de7\u5999\u7684\u52a8\u4f5c\uff0c\u6280\u827a\uff1b\u8be1\u8ba1\uff0c\u82b1\u62db\uff1b\u8f6e \u73ed\uff0c\u8f6e\u503c\uff1bn.f. \u5854\uff0c\u697c\uff1b\u57ce\u697c\uff0c\u70ae\u697c v.i. \u6d3b\u7740\uff1b\u751f\u5b58\uff1b\u5c45\u4f4f\u5728\uff0c\u751f\u6d3b\u5728\uff1b\u8fc7\u2026\u2026\u751f\u6d3b\uff1b\u751f\u6d3b\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 190,
    word: "vivre",
    phonetic: "[vivr]",
    type: "",
    translation: "\u5904\u4e16\uff0c\u505a\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 191,
    word: "main",
    phonetic: "[m\u025b\u0303]",
    type: "",
    translation: "n.f. \u624b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 192,
    word: "corps",
    phonetic: "[k\u0254r]",
    type: "",
    translation: "n.m. \u8eab\u4f53\uff0c\u8eaf\u4f53\uff1b\u8089\u4f53\uff1b\u8eaf\u5e72\uff1b\u5c38\u4f53\uff1b\u7269\u4f53\uff1b\u56e2\u4f53 n.m. \u767e\u4e07\uff1b\u767e\u4e07\u6cd5\u90ce\u3001\u767e\u4e07\u5143\u6216\u767e\u4e07\u9551\u7b49\uff1b\u5de8\u5927\u6570\u76ee\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 193,
    word: "million",
    phonetic: "[milj\u0254\u0303]",
    type: "",
    translation: "\u8bb8\u8bb8\u591a\u591a\uff0c \u65e0\u6570\uff1b\u4e00\u4e07\u6cd5\u90ce[\u6309\u65e7\u6cd5\u90ce\u4e00\u767e\u4e07\u6cd5\u90ce\u6298\u5408\u65b0 \u6cd5\u90ce\u4e00\u767e\u4e07\u751f\u4e01\u8ba1\u7b97] a. \u8d1f\u8d23\u7684\uff0c\u6709\u8d23\u4efb\u611f\u7684\uff1b\u5e94\u8d1f\u8d23\u7684\uff0c\u6709\u8d23\u4efb\u7684\uff1b\u4f5c\u4e3a\u539f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 194,
    word: "responsable",
    phonetic: "[r\u03b5sp\u0254\u0303sabl]",
    type: "",
    translation: "\u56e0\u7684\uff1bn. \u8d1f\u8d23\u4eba v.i. \u558a\uff0c\u53eb\uff1b\u5927\u58f0\u53eb\u56b7\uff1b\uff08\u7269\u4f53\uff09\u560e\u5431\u54cd\uff1bv.t. \u547c\u558a\uff0c\u558a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 195,
    word: "crier",
    phonetic: "[krije]",
    type: "",
    translation: "\u53eb\uff0c\u53eb\u56b7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 196,
    word: "assez",
    phonetic: "[ase]",
    type: "",
    translation: "adv. \u591f\uff0c\u8db3\u591f\uff1b\u76f8\u5f53\uff1b\u975e\u5e38",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 197,
    word: "quoi",
    phonetic: "[kwa]",
    type: "",
    translation: "pron.relat. \u4ec0\u4e48 a. \u7ea2\u989c\u8272\u7684\uff1b\u8138\u7ea2\u7684\uff1b\u7ea2\u68d5\u8272\u7684\uff1b\u70e7\u7ea2\u7684\uff1bn.m. \u7ea2\u989c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 198,
    word: "rouge",
    phonetic: "[ru\u0292]",
    type: "",
    translation: "\u8272\uff1b\u53e3\u7ea2\uff1b\u7ea2\u8272\u4fe1\u53f7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 199,
    word: "raisonnable",
    phonetic: "[r\u03b5z\u0254nabl]",
    type: "",
    translation: "a. \u6709\u7406\u6027\u7684\uff0c\u6709\u7406\u667a\u7684\uff1b\u5408\u7406\u7684\uff1b\u516c\u9053\u7684\uff0c\u9002\u5f53\u7684 v.i. \u5269\u4e0b\uff0c\u7559\u4e0b\uff0c\u505c\u7559\uff1b\u9017\u7559\uff1b\u7559\u5728\u67d0\u5904\u4e0d\u52a8\uff1b\u4fdd\u6301\uff0c\u5904",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 200,
    word: "rester",
    phonetic: "[r\u03b5ste]",
    type: "",
    translation: "\u4e8e\uff08\u67d0\u79cd\u72b6\u6001\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 201,
    word: "dormir",
    phonetic: "[d\u0254rmir]",
    type: "",
    translation: "v.i. \u7761\uff0c\u7761\u89c9\uff1b\u6d88\u6781\uff0c\u4e0d\u632f\u4f5c\uff1b\u9759\u6b62\uff0c\u505c\u6ede",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 202,
    word: "mois",
    phonetic: "[mwa]",
    type: "",
    translation: "n.m. \u6708\uff0c\u6708\u4efd\uff1b\u4e00\u4e2a\u6708\u7684\u65f6\u95f4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 203,
    word: "ensemble",
    phonetic: "[\u0251\u0303s\u0251\u0303bl]",
    type: "",
    translation: "adv. \u5171\u540c\uff0c\u4e00\u8d77\uff1b\u540c\u65f6\uff1bn.m. \u5168\u90e8\uff0c\u5168\u4f53\uff1b\u6574\u4f53\uff1b\u540c\u65f6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 204,
    word: "chaise",
    phonetic: "[\u222b\u03b5z]",
    type: "",
    translation: "n.f. \u6905\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 205,
    word: "chance",
    phonetic: "[\u222b\u0251\u0303s]",
    type: "",
    translation: "n.f. \u8fd0\u6c14\uff1b\u5e78\u8fd0\uff0c\u597d\u8fd0\uff1b\u673a\u4f1a\uff0c\u53ef\u80fd\u6027 v.t. \u8f6c\u5411\uff0c\u8c03\u8f6c\uff1b\u7ffb\uff1b\u7ffb\u8f6c\uff1b\u4f7f\u65cb\u8f6c\uff0c\u8f6c\u52a8\uff1b\u6405\u62cc\uff1b[\u5f71]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 206,
    word: "tourner",
    phonetic: "[turne]",
    type: "",
    translation: "\u62cd\u6444\uff1bv.i. \u8f6c\u52a8\uff0c\u65cb\u8f6c\uff0c\u8fd0\u8f6c\uff1b\u8e31\u6765\u8e31\u53bb\uff1b\u56f4\u7ed5\uff0c\u4ee5\u2026\u2026 \u4e3a\u4e2d\u5fc3\uff1b\u5de1\u56de\u6f14\u51fa\uff1b\u62d0\u5f2f\uff0c\u8f6c\u5411\uff1b\u6539\u53d8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 207,
    word: "diff\u00e9rent",
    phonetic: "[difer\u0251\u0303]",
    type: "",
    translation: "a. \u4e0d\u540c\u7684\uff0c\u76f8\u5f02\u7684\uff1b\u53d8\u6210\u4e0d\u540c\u7684\uff0c\u53d8\u6837\u7684 n.m. \u5c0f\u5706\u70b9\uff1b\u6807\u70b9\uff1b\u53e5\u53f7\uff1b\u5206\u6570\uff1b\u767e\u5206\u70b9\uff1b\u5730\u65b9\uff1b\u8981",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 208,
    word: "point",
    phonetic: "[pw\u025b\u0303]",
    type: "",
    translation: "\u70b9\uff1b\u7a0b\u5ea6 6 of 12 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. v.i. \u518d\u6765\uff1b\u8fd4\u56de\uff0c\u56de\u6765\uff1b\u91cd\u65b0\u51fa\u73b0\uff1b\u5728\u8bb0\u5fc6\u4e2d\u91cd\u73b0\uff1b\u56de",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 209,
    word: "revenir",
    phonetic: "[r\u0259vnir]",
    type: "",
    translation: "\u590d\uff0c\u6062\u590d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 210,
    word: "village",
    phonetic: "[vila\u0292]",
    type: "",
    translation: "n.m. \u6751\u5e84\uff0c\u4e61\u6751\uff1b\u5168\u6751\u7684\u4eba v.t. \u91cd\u65b0\u770b\uff0c\u518d\u770b\uff1b\u91cd\u89c1\u67d0\u4eba\uff0c\u518d\u89c1\u67d0\u4eba\uff1b\u590d\u67e5\uff0c\u590d\u6838\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 211,
    word: "revoir",
    phonetic: "[r(\u0259)vwar]",
    type: "",
    translation: "\u590d\u5ba1\uff1b\u590d\u4e60\uff0c\u6e29\u4e60",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 212,
    word: "\u00e9couter",
    phonetic: "[ekute]",
    type: "",
    translation: "v.t. \u542c\uff1b\u542c\u53d6\uff1b\u542c\u4ece a. \u58ee\u4e3d\u7684\uff0c\u5b8f\u4f1f\u7684\uff1b\u8c6a\u534e\u7684\uff1b\u6781\u7f8e\u7684\uff1b\u6781\u597d\u7684\uff1b\u5f88\u51fa\u8272",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 213,
    word: "magnifique",
    phonetic: "[ma\u0272ifik]",
    type: "",
    translation: "\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 214,
    word: "int\u00e9resser",
    phonetic: "[\u025b\u0303ter\u03b5se]",
    type: "",
    translation: "ou [\u025b\u0303terese] v.t. \u5173\u7cfb\u5230\uff0c\u6d89\u53ca\uff1b\u4f7f\u611f\u5174\u8da3\uff0c\u5f15\u8d77\u6ce8\u610f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 215,
    word: "choisir",
    phonetic: "[\u222bwazir]",
    type: "",
    translation: "v.t. \u6311\u9009\uff0c\u9009\u62e9\uff1b\u9009\u5b9a\uff0c\u51b3\u5b9a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 216,
    word: "semaine",
    phonetic: "[s(\u0259)m\u03b5n]",
    type: "",
    translation: "n.f. \u4e00\u5468\uff1b\u5de5\u4f5c\u5468\uff1b\u5468\uff0c\u661f\u671f\uff1b\u5468\u85aa v.t. \u6570\uff1b\u8ba1\u7b97\uff1b\u7b97\u4e0a\uff0c\u5305\u62ec\uff1b\u62e5\u6709\uff1b\u7b97\u5165\uff0c\u7b97\u4f5c\uff1bv.i.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 217,
    word: "compter",
    phonetic: "[k\u0254\u0303te]",
    type: "",
    translation: "\u6570\uff0c\u8ba1\u6570\uff1b\u8ba1\u7b97\uff1b\u5177\u6709\u4e00\u5b9a\u91cd\u8981\u6027\uff0c\u8d77\u4e00\u5b9a\u4f5c\u7528 adj.num.card.\uff0c adj.inv. \uff08\u7b2c\uff09\u5341\u4e00 \uff1b\u7b2c\u5341\u4e00\u53f7\u623f\u95f4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 218,
    word: "onze",
    phonetic: "[\u0254\u0303z]",
    type: "",
    translation: "\u6216\u684c\u5b50\uff1b\uff08\u4e00\u4e2a\u6708\u4efd\u7684\uff09\u5341\u4e00\u65e5\uff1b\uff0811\u4eba\u7ec4\u6210\u7684\uff09\u8db3\u7403 \u961f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 219,
    word: "eux",
    phonetic: "[\u00f8]",
    type: "",
    translation: "pron.pers.m.pl. \u4ed6\u4eec\uff0c\u5b83\u4eec",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 220,
    word: "mer",
    phonetic: "[m\u03b5r]",
    type: "",
    translation: "n.f. \u6d77\uff1b\u6d77\u6c34\uff1b\u6d77\u8fb9\uff1b\u6d77\u6f6e\uff1b\u5927\u91cf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 221,
    word: "ville",
    phonetic: "[vil]",
    type: "",
    translation: "n.f. \u57ce\u5e02\uff0c\u90fd\u5e02\uff1b\u5168\u57ce\u5c45\u6c11\uff1b\u57ce\u5e02\u751f\u6d3b adj.poss. \u60a8\u7684\uff0c\u4f60\u7684\uff1b\u4f60\u4eec\u7684\uff1b\u5bf9\u4e8e\u60a8\uff08\u4f60\uff09\u7684\uff1b\u5bf9\u4e8e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 222,
    word: "votre",
    phonetic: "[v\u0254tr]",
    type: "",
    translation: "\u4f60\u4eec\u7684\uff08\u6307\u5ba2\u4f53\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 223,
    word: "activit\u00e9",
    phonetic: "[aktivite]",
    type: "",
    translation: "n.f. \u6d3b\u52a8 v.t. \u518d\u62ff\uff0c\u518d\u53d6\uff1b\u62ff\u56de\uff1b\u6536\u56de\uff1b\u6062\u590d\uff1b\u593a\u56de\uff0c\u6536\u590d\uff1b\u91cd\u65b0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 224,
    word: "reprendre",
    phonetic: "[r(\u0259)pr\u0251\u0303dr]",
    type: "",
    translation: "\u5f00\u59cb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 225,
    word: "visiter",
    phonetic: "[vizite]",
    type: "",
    translation: "v.t. \u53c2\u89c2\uff0c\u6e38\u89c8\uff1b\u89c6\u5bdf\uff0c\u5de1\u89c6\uff1b\u68c0\u67e5\uff0c\u641c\u67e5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 226,
    word: "d\u00e9jeuner",
    phonetic: "[de\u0292\u0153ne]",
    type: "",
    translation: "n.m. \u5348\u996d\uff0c\u5348\u9910\uff1b\u5348\u9910\u83dc\u80b4\uff1bv.i. \u5403\u65e9\u996d\uff1b\u5403\u5348\u996d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 227,
    word: "importance",
    phonetic: "[\u025b\u0303p\u0254rt\u0251\u0303s]",
    type: "",
    translation: "n.f. \u91cd\u8981\uff0c\u91cd\u8981\u6027\uff0c\u91cd\u5927\uff1b\u58f0\u671b\uff0c\u5f71\u54cd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 228,
    word: "ann\u00e9e",
    phonetic: "[ane]",
    type: "",
    translation: "n.f. \u5e74\uff0c\u5e74\u4efd\uff1b\u5e74\u5ea6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 229,
    word: "partir",
    phonetic: "[partir]",
    type: "",
    translation: "v.i. \u51fa\u53d1\uff0c\u79bb\u53bb\uff0c\u52a8\u8eab\uff1b\u8d77\u8dd1\uff1b\u542f\u52a8\uff0c\u53d1\u52a8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 230,
    word: "notre",
    phonetic: "[n\u0254tr]",
    type: "",
    translation: "adj.poss. \u6211\u4eec\u7684\uff1b\u6211\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 231,
    word: "rendre",
    phonetic: "[r\u0251\u0303dr]",
    type: "",
    translation: "v.t. \u5f52\u8fd8\uff1b\u9000\u8fd8\uff1b\u4f7f\u6062\u590d\uff1b\u56de\u62a5\uff1b\u4f5c\u51fa\uff1b\u51fa\u4ea7\uff1b\u4f7f\u53d8\u4e3a v.t. \u6572\uff0c\u6253\uff0c\u62cd\uff1b\u6253\u4e2d\uff0c\u51fb\u4e2d\uff1b\u51b2\u5236\uff1b\u4fb5\u88ad\uff0c\u4f7f\u906d\u53d7\uff1b\u4f7f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 232,
    word: "frapper",
    phonetic: "[frape]",
    type: "",
    translation: "\u4ea7\u751f\u5f3a\u70c8\u5370\u8c61\uff0c\u6253\u52a8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 233,
    word: "id\u00e9e",
    phonetic: "[ide]",
    type: "",
    translation: "n.f. \u770b\u6cd5\uff0c\u60f3\u6cd5\uff1b\u6982\u5ff5\uff1b\u89c2\u5ff5\uff1b\u6982\u51b5\uff1b\u8ba1\u5212\uff1b\u601d\u60f3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 234,
    word: "ainsi",
    phonetic: "[\u025b\u0303si]",
    type: "",
    translation: "adv. 1.\u8fd9\u6837\uff0c\u5982\u6b64\uff1b\u540c\u6837\uff0c\u4e00\u6837\uff1b 2.\u7531\u6b64\uff0c\u56e0\u6b64",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 235,
    word: "v\u00e9ritable",
    phonetic: "[veritabl]",
    type: "",
    translation: "a. \u771f\u5b9e\u7684\uff0c\u786e\u5b9e\u7684\uff1b\u771f\u7684\uff1b\u771f\u6b63\u7684[\u6307\u540d\u526f\u5176\u5b9e\u7684] n.m. \u6c99\u6f20\uff1b\u8352\u65e0\u4eba\u70df\u7684\u5730\u65b9\uff1b\u504f\u50fb\u7684\u5730\u65b9\uff1ba. \u8352\u65e0\u4eba\u70df",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 236,
    word: "d\u00e9sert",
    phonetic: "[dez\u03b5r, -t]",
    type: "",
    translation: "\u7684\uff0c\u8352\u51c9\u7684\uff1b\u51b7\u6e05\u7684\uff0c\u50fb\u9759\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 237,
    word: "dessiner",
    phonetic: "[desine]",
    type: "",
    translation: "v.t. \u753b\uff1b\u7ed8\u753b\uff1b\u4f7f\u8f6e\u5ed3\u3001\u7ebf\u6761\u7a81\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 238,
    word: "\u00e9t\u00e9",
    phonetic: "[ete]",
    type: "",
    translation: "n.m. \u590f\uff0c\u590f\u5b63\uff0c\u590f\u5929 pr\u00e9p.\uff0c adv. \u90a3\u662f\uff0c\u90a3\u5c31\u662f\uff1b\u8fd9\u662f\uff0c\u8fd9\u5c31\u662f\uff1b\u4ee5\u4e0a\u5c31",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 239,
    word: "voil\u00e0",
    phonetic: "[vwala]",
    type: "",
    translation: "\u662f\uff0c\u4e0a\u9762\u5c31\u662f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 240,
    word: "portrait",
    phonetic: "[p\u0254rtr\u03b5]",
    type: "",
    translation: "n.m. \u8096\u50cf\uff0c\u753b\u50cf\uff1b\u76f8\u7247\uff1b\u63cf\u7ed8\uff1b\u8138\uff0c\u9762\u5b54",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 241,
    word: "faute",
    phonetic: "[fot]",
    type: "",
    translation: "n.f. \u9519\u8bef\uff1b\u8fc7\u5931\uff0c\u8fc7\u9519\uff1b\u5dee\u9519\uff1b\u8fdd\u7ae0\uff1b\u72af\u89c4\uff1b\u5931\u8bef",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 242,
    word: "peintre",
    phonetic: "[p\u025b\u0303tr]",
    type: "",
    translation: "n.m. \u753b\u5bb6\uff0c\u753b\u5e08\uff1b\u6cb9\u6f06\u5de5\uff0c\u6f06\u5320 a. \u5f00\u7740\u7684\uff1b\u5f00\u653e\u7684\uff1b\u6613\u4e8e\u63a5\u53d7\u7684\uff1b\u5766\u7387\u7684\uff1b\u5f00\u6717\u7684\uff1b\u516c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 243,
    word: "ouvert",
    phonetic: "[uv\u03b5r, -t]",
    type: "",
    translation: "\u5f00\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 244,
    word: "fatigue",
    phonetic: "[fatig]",
    type: "",
    translation: "n.f. \u75b2\u4e4f\uff0c\u52b3\u7d2f 7 of 12 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 245,
    word: "faim",
    phonetic: "[f\u025b\u0303]",
    type: "",
    translation: "n.f. \u997f\uff0c\u9965\u997f\uff1b\u9965\u8352",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 246,
    word: "perdre",
    phonetic: "[p\u03b5rdr]",
    type: "",
    translation: "v.t. \u5931\u53bb\uff1b\u820d\u5f03\uff1b\u4e27\u5931\uff1b\u4e22\u5931\uff1b\u8f93\uff0c\u8d25 adv. \u8f7b\u8f7b\u5730\uff1b\u6084\u6084\u5730\uff1b\u6162\u6162\u5730\uff1b\u4e0d\u77e5\u4e0d\u89c9\u5730\uff1b\u5b89\u5b81\u5730\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 247,
    word: "doucement",
    phonetic: "[dusm\u0251\u0303]",
    type: "",
    translation: "\u6109\u5feb\u5730\uff1b\u5c0f\u5fc3\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 248,
    word: "endroit",
    phonetic: "[\u0251\u0303drwa]",
    type: "",
    translation: "n.m. \u5730\u65b9\uff0c\u573a\u6240\uff1b\uff08\u8eab\u4f53\u7b49\u7684\uff09\u90e8\u4f4d\uff1b\u5c45\u4f4f\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 249,
    word: "poche",
    phonetic: "[p\u0254\u222b]",
    type: "",
    translation: "n.f. \u8863\u888b\uff0c\u53e3\u888b\uff1b\u888b\uff0c\u5305",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 250,
    word: "longtemps",
    phonetic: "[l\u0254\u0303t\u0251\u0303]",
    type: "",
    translation: "adv. \u957f\u4e45\u5730\uff0c\u5f88\u4e45",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 251,
    word: "caisse",
    phonetic: "[k\u03b5s]",
    type: "",
    translation: "n.f. 1.\u7bb1\u5b50\uff0c\u5916\u58f3 2.\u6536\u94f6\u53f0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 252,
    word: "herbe",
    phonetic: "[\u03b5rb]",
    type: "",
    translation: "n.f. \u8349\uff0c\u8349\u672c\u690d\u7269\uff1b\u8349\u5730\uff0c\u8349\u576a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 253,
    word: "prince",
    phonetic: "[pr\u025b\u0303s]",
    type: "",
    translation: "n.m. \u541b\u4e3b\uff0c\u541b\u738b\uff1b\u738b\u5b50\uff1b\u592a\u5b50\uff1b\u4eb2\u738b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 254,
    word: "hasard",
    phonetic: "[azar]",
    type: "",
    translation: "\u865a\u97f3H n.m. \u673a\u9047\uff0c\u5de7\u5408\uff1b\u98ce\u9669\uff1b\u5076\u7136\uff0c\u5076\u7136\u6027",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 255,
    word: "avion",
    phonetic: "[avj\u0254\u0303]",
    type: "",
    translation: "n.m. \u98de\u673a v.i. \u98de\uff0c\u98de\u7fd4\uff1b\u98de\u884c\uff1b\u98de\u821e\uff1bv.t. \u5077\u7a83\uff0c\u62a2\u52ab\uff1b\u8bc8\u9a97\uff1b\u5bb0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 256,
    word: "voler",
    phonetic: "[v\u0254le]",
    type: "",
    translation: "\u4eba\uff0c\u83b7\u66b4\u5229",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 257,
    word: "aussit\u00f4t",
    phonetic: "[osito]",
    type: "",
    translation: "adv. \u7acb\u523b\uff0c\u7acb\u5373\uff0c\u5373\u523b\uff0c\u9a6c\u4e0a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 258,
    word: "brusquement",
    phonetic: "[brysk\u0259m\u0251\u0303]",
    type: "",
    translation: "adv. \u7c97\u66b4\u5730\uff0c \u751f\u786c\u5730\uff1b\u7a81\u7136\u5730\uff0c \u6025\u5267\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 259,
    word: "durer",
    phonetic: "[dyre]",
    type: "",
    translation: "v.i. \u6301\u7eed\uff0c\u5ef6\u7eed\uff1b\u6301\u7eed\u5f88\u4e45\uff0c\u62d6\u5ef6\u5f88\u957f\u65f6\u95f4\uff1b\u6301\u4e45\uff1b\u4fdd\u6301 1.\u6d78\u5165\uff1b\u624e\u8fdb\uff1b\u4f38\u8fdb\uff0c\u6df1\u5165\uff1b 2.\u4f7f\u9677\uff1b \"3.v.i. \u6f5c\u6c34\uff1b\u7a81",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 260,
    word: "plonger",
    phonetic: "[pl\u0254\u0303\u0292e]",
    type: "",
    translation: "\u7136\u4e0b\u964d\uff1b 4.\u6c89\u5165\uff0c\u9677\u5165\uff0c\u4e13\u5fc3\u4e8e\uff1b\u4fef\u89c6 \" v.t. \u5e26\u8d70\uff0c\u62ff\u8d70\uff0c\u8fd0\u8d70\uff1b\u593a\u8d70\uff0c\u593a\u53bb\uff1b\u51b2\u8d70\uff0c\u5377\u8d70\uff1b\u4f7f\u65e0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 261,
    word: "emporter",
    phonetic: "[\u0251\u0303p\u0254rte]",
    type: "",
    translation: "\u6cd5\u81ea\u5236 v.t. \u7ed1\uff0c\u7f1a\uff0c\u56fa\u5b9a\uff1b\u7cfb\uff0c\u6263\uff1b\u4f7f\u7cfb\u4e8e\uff0c\u4f7f\u7ed3\u5408\uff1b\u7ed9\u4e88\uff0c\u8d4b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 262,
    word: "attacher",
    phonetic: "[ata\u222be]",
    type: "",
    translation: "\u4e88",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 263,
    word: "para\u00eetre",
    phonetic: "[par\u03b5tr]",
    type: "",
    translation: "v.i. \u51fa\u73b0\uff0c\u9732\u51fa\uff1b\u9732\u9762\uff0c\u5230\u6765\uff1b\u51fa\u7248\uff0c\u53d1\u8868\uff1b\u597d\u50cf\uff0c\u663e\u5f97 n.f. \u53f3\u9762\uff0c \u53f3\u8fb9\uff0c \u53f3\u65b9\uff1b\uff08\u9053\u8def\u7684\uff09\u53f3\u8fb9\uff1b[\u653f]\u53f3\u6d3e\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 264,
    word: "droite",
    phonetic: "[drwat]",
    type: "",
    translation: "\u53f3\u7ffc\uff1b \u53f3\u6d3e\u653f\u515a\uff1b\u53f3\u624b\uff1b[\u6570]\u76f4\u7ebf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 265,
    word: "tellement",
    phonetic: "[t\u03b5lm\u0251\u0303]",
    type: "",
    translation: "adv. \u8fd9\u6837\u5730\uff0c \u5982\u6b64\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 266,
    word: "seconde",
    phonetic: "[s\u0259g\u0254\u0303d]",
    type: "",
    translation: "n.f. \u79d2\uff1b\u77ac\u95f4\uff0c\u7247\u523b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 267,
    word: "quelquefois",
    phonetic: "[k\u03b5lk\u0259fwa]",
    type: "",
    translation: "adv. \u6709\u65f6\uff0c\u5076\u5c14 n.m. \u574f\uff0c\u7cdf\uff1b\u6076\uff1b\u635f\u5bb3\uff0c\u7978\u5bb3\uff1b\u75bc\u75db\uff1b\u4e0d\u9002\uff1b\u75be\u75c5\uff1b\u56f0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 268,
    word: "mal",
    phonetic: "[mal]",
    type: "",
    translation: "\u96be\uff1b\u574f\u8bdd\uff0c\u574f\u5904\uff1badv. \u574f\uff0c\u7cdf\uff0c\u4e0d\u597d\uff0c\u6076\u52a3\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 269,
    word: "causer",
    phonetic: "[koze]",
    type: "",
    translation: "v.t. \u5f15\u8d77\uff0c\u9020\u6210\uff1bv.i. \u4ea4\u8c08\uff0c\u95f2\u8c08",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 270,
    word: "costume",
    phonetic: "[k\u0254stym]",
    type: "",
    translation: "n.m. \u670d\u88c5\uff1b\u7537\u5f0f\uff08\u6210\u5957\uff09\u897f\u670d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 271,
    word: "d\u00e9tail",
    phonetic: "[detaj]",
    type: "",
    translation: "n.m. \u7ec6\u8282\uff0c\u7ec6\u90e8\uff1b\u96f6\u552e\uff1b\u8be6\u7ec6\uff0c\u8be6\u5c3d\uff0c\u8be6\u7ec6\u60c5\u51b5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 272,
    word: "gagner",
    phonetic: "[ga\u0272e]",
    type: "",
    translation: "v.t. \u8d5a\u5f97\uff1b\u8d62\uff1b\u83b7\u5f97\uff1b\u5230\u8fbe\uff1b\u8513\u5ef6\u5230\uff1b\u8282\u7701",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 273,
    word: "preuve",
    phonetic: "[pr\u0153v]",
    type: "",
    translation: "n.f. \u8bc1\u636e\uff0c\u8bc1\u660e\uff1b\u6807\u5fd7\uff0c\u8868\u793a a. \u5e73\u9759\u7684\uff0c\u5b89\u7a33\u7684\uff0c\u5b89\u9759\u7684\uff1b\u4e0d\u5435\u95f9\u7684\uff1b\u5b89\u5b81\u7684\uff0c\u606c\u9759",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 274,
    word: "tranquille",
    phonetic: "[tr\u0251\u0303kil]",
    type: "",
    translation: "\u7684 n\u00e0 xi\u0113 (\u5f62) ces (\u4ee3) les; ceux (celles) -l\u00e0; celui, 278 ceux celle, ceux, celles",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 275,
    word: "livrer",
    phonetic: "[livre]",
    type: "",
    translation: "v.t. \u4ea4\u51fa\uff0c\u4ea4\u7ed9\uff1b\u9001\u4ea4\uff1b\u4e22\u5f03\uff1b\u51fa\u5356\uff1b\u53db\u53d8\uff1b\u4ea4\uff08\u8d27\uff09 adv. \u5982\u6b64\uff0c\u90a3\u4e48\u591a\uff0c \u5230\u8fd9\u822c\u7a0b\u5ea6\uff1b\u90a3\u4e48\u2026\u4ee5\u81f3\u4e8e\uff0c \u5982",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 276,
    word: "tant",
    phonetic: "[t\u0251\u0303]",
    type: "",
    translation: "\u6b64\u2026\u4ee5\u81f3\u4e8e a. \u60b2\u4f24\u7684\uff1b\u5fe7\u6101\u7684\uff1b\u4ee4\u4eba\u96be\u8fc7\u7684\uff0c\u60b2\u60e8\u7684\uff1b\u9634\u6697\u7684\uff0c\u9634",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 277,
    word: "triste",
    phonetic: "[trist]",
    type: "",
    translation: "\u6c89\u7684 v.t. \u653e\u56de\uff1b\u9001\u56de\uff1b\u4f7f\u6062\u590d\u539f\u4f4d\uff0c\u4f7f\u91cd\u65b0\u5904\u4e8e\u2026\u2026\uff1b\u91cd\u65b0\u7a7f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 278,
    word: "remettre",
    phonetic: "[r(\u0259)m\u03b5tr]",
    type: "",
    translation: "\u4e0a\uff0c\u91cd\u65b0\u6234\u4e0a\uff1b\u518d\u914d\uff0c\u518d\u8865\uff0c\u518d\u52a0\uff0c\u518d\u6dfb\uff1b\u9001\u4ea4\uff1b\u63a8\u8fdf\uff1b \u62d6\u5ef6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 279,
    word: "semblable",
    phonetic: "[s\u0251\u0303blabl]",
    type: "",
    translation: "a. \u76f8\u4f3c\u7684\uff0c\u76f8\u50cf\u7684\uff1b\u5982\u6b64\u7684\uff1bn. \u540c\u6837\u7684\u4eba\uff0c\u540c\u7c7b\u7684\u4e1c\u897f 8 of 12 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. n.m. \u51fa\u53d1\uff1b\u79bb\u5f00\uff1b\u8d77\u98de\uff1b\u542f\u822a\uff1b\u5f00\u7aef\uff0c\u5f00\u59cb\uff1b\u51fa\u53d1\u70b9\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 280,
    word: "d\u00e9part",
    phonetic: "[depar]",
    type: "",
    translation: "\u8d77\u70b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 281,
    word: "effort",
    phonetic: "[ef\u0254r]",
    type: "",
    translation: "n.m. \u7528\u529b\uff1b\u52aa\u529b\uff0c\u7aed\u529b\uff0c\u5c3d\u529b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 282,
    word: "invisible",
    phonetic: "[\u025b\u0303vizibl]",
    type: "",
    translation: "a. \u770b\u4e0d\u89c1\u7684\uff0c\u4e0d\u53ef\u89c1\u7684 v.t. \u63a8\uff0c\u63a8\u8fdb\uff1b\u9a71\uff0c\u8d76\uff1b\u4fc3\u4f7f\uff0c\u4fc3\u8fdb\uff1b\u53d1\u51fa\uff08\u558a\u53eb\u58f0\uff09\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 283,
    word: "pousser",
    phonetic: "[puse]",
    type: "",
    translation: "v.i. \u751f\u957f\uff0c\u957f\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 284,
    word: "arracher",
    phonetic: "[ara\u222be]",
    type: "",
    translation: "v.t.\uff08\u8fde\u6839\uff09\u62d4\uff1b\u593a\u53bb\uff0c\u4e89\u5f97\uff1b\u529b\u593a\uff0c\u5de7\u593a\uff1b\u626f\u4e0b\uff0c\u62d4\u4e0b pr\u00e9p. \u81ea\u2026\u2026\u4ee5\u6765\uff0c\u4ece\u2026\u2026\u4ee5\u540e\uff1b\u4ece\u2026\u2026\uff0c\u81ea\u2026\u2026\uff1badv.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 285,
    word: "depuis",
    phonetic: "[d\u0259p\u0265i]",
    type: "",
    translation: "\u4ece\u6b64\u4ee5\u540e\uff0c\u6b64\u540e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 286,
    word: "voici",
    phonetic: "[vwasi]",
    type: "",
    translation: "pr\u00e9p.\uff0c adv. \u8fd9\u662f\uff0c\u8fd9\u5c31\u662f\uff1b\u4ee5\u4e0b\u5c31\u662f\uff0c\u4e0b\u9762\u5c31\u662f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 287,
    word: "pleurer",
    phonetic: "[pl\u0153re]",
    type: "",
    translation: "v.i. \u54ed\uff0c\u6d41\u6cea",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 288,
    word: "cependant",
    phonetic: "[s\u0259p\u0251\u0303d\u0251\u0303]",
    type: "",
    translation: "adv. \u53ef\u662f\uff0c\u7136\u800c\uff0c\u4f46\u662f n.f. \u661f\uff1b\u6052\u661f\uff1b\u661f\u72b6\u7269\uff1b\u661f\u7ae0\uff1b\u661f\uff08\u7ea7\uff09\uff1b\uff08\u620f\u5267\u3001\u7535\u5f71",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 289,
    word: "\u00e9toile",
    phonetic: "[etwal]",
    type: "",
    translation: "\u7b49\u7684\uff09\u660e\u661f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 290,
    word: "d\u00e9couvrir",
    phonetic: "[dekuvrir]",
    type: "",
    translation: "v.t. \u63ed\u5f00\u76d6\u5b50\uff0c\u63ed\u5f00\u8986\u76d6\u7269\uff1b\u9732\u51fa\uff0c\u66b4\u9732\uff1b\u53d1\u73b0 a. \u6613\u788e\u7684\uff0c\u8106\u7684\uff1b\u4e0d\u575a\u56fa\u7684\uff0c\u4e0d\u7262\u56fa\u7684\uff1b\uff08\u4f53\u8d28\uff09\u865a\u5f31",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 291,
    word: "fragile",
    phonetic: "[fra\u0292il]",
    type: "",
    translation: "\u7684\uff0c\u8106\u5f31\u7684\uff1b\u4e0d\u7a33\u56fa\u7684\uff0c\u4e0d\u7262\u9760\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 292,
    word: "front",
    phonetic: "[fr\u0254\u0303]",
    type: "",
    translation: "n.m. \u524d\u989d\uff1b\u9876\uff0c\u5cf0\uff1b\u6b63\u9762\uff1b\u524d\u7ebf\uff0c\u9635\u7ebf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 293,
    word: "cheveu",
    phonetic: "[\u222b(\u0259)v\u00f8]",
    type: "",
    translation: "n.m. \u5934\u53d1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 294,
    word: "trembler",
    phonetic: "[tr\u0251\u0303ble]",
    type: "",
    translation: "v.i. \u6296\u52a8\uff0c\u6447\u52a8\uff1b\u98a4\u6296\uff1b\u5730\u9707\uff1b\u80c6\u6218\u5fc3\u60ca\uff1b\u5bb3\u6015",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 295,
    word: "lendemain",
    phonetic: "[l\u0251\u0303dm\u025b\u0303]",
    type: "",
    translation: "n.m. \u6b21\u65e5\uff0c\u7fcc\u65e5\uff1b\u672a\u6765\uff0c\u5c06\u6765",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 296,
    word: "trente",
    phonetic: "[tr\u0251\u0303t]",
    type: "",
    translation: "adj.num.card.\uff0c adj.inv. \u4e09\u5341 v.t. \u62c9\uff0c\u7275\uff0c\u62d6\uff1b\u53d1\u5c04\uff1b\u5f00\u67aa\u5c04\u51fb\uff1b\u62bd\u51fa\uff1b\u4f7f\u6446\u8131\uff1b\u5f97",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 297,
    word: "tirer",
    phonetic: "[tire]",
    type: "",
    translation: "\u5230\uff1b\u63d0\u53d6\uff0c\u62bd\u53d6\uff1b\u63a8\u65ad\u51fa\uff1b\u62bd\uff08\u7b7e\uff09\uff0c\u6478\uff08\u5f69\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 298,
    word: "bruit",
    phonetic: "[br\u0265i]",
    type: "",
    translation: "n.m. \u58f0\u97f3\uff0c\u566a\u58f0\uff0c\u5608\u6742\u58f0\uff1b\u6d88\u606f\uff0c\u98ce\u58f0\uff0c\u4f20\u95fb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 299,
    word: "justement",
    phonetic: "[\u0292yst\u0259m\u0251\u0303]",
    type: "",
    translation: "adv. \u6b63\u786e\u5730\uff0c\u786e\u5207\u5730\uff0c\u6070\u5f53\u5730\uff1b\u6b63\u597d\uff0c\u6070\u597d v.t. \u6307\u51fa\uff0c\u6307\u793a\uff1b\u51fa\u793a\uff1b\u70ab\u8000\uff0c\u5356\u5f04\uff1b\u8bf4\u660e\uff0c\u8868\u660e\uff1b\u663e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 300,
    word: "montrer",
    phonetic: "[m\u0254\u0303tre]",
    type: "",
    translation: "\u793a\uff0c\u8868\u73b0\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 301,
    word: "cadeau",
    phonetic: "[kado]",
    type: "",
    translation: "n.m. \u793c\u7269\uff0c\u793c\u54c1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 302,
    word: "tas",
    phonetic: "[t\u0251]",
    type: "",
    translation: "n.m. \u5806\uff0c\u579b\uff1b\u5de5\u5730 a. \u5feb\u7684\uff1b\u8fc5\u901f\u7684\uff0c\u5306\u5fd9\u7684\uff1b\u654f\u6377\u7684\uff1b\u901f\u6210\u7684\uff1bn.m. \u7279\u5feb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 303,
    word: "rapide",
    phonetic: "[rapid]",
    type: "",
    translation: "\u5217\u8f66 v.t. \u62ff\u7740\uff1b\u6267\uff0c\u6301\uff1b\u6293\u4f4f\uff0c\u902e\u4f4f\uff1b\u638c\u63e1\uff0c\u62e5\u6709\uff1b\u7ecf\u8425\uff0c\u5f00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 304,
    word: "tenir",
    phonetic: "[t(\u0259)nir]",
    type: "",
    translation: "\u8bbe\uff1b\u638c\u7ba1\uff1b\u4fdd\u6301\uff0c\u4f7f\u5904\u4e8e\uff1b\u4fe1\u5b88\uff0c\u9075\u5b88\uff1b\u5bb9\u7eb3\uff0c\u88c5\u5f97\u4e0b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 305,
    word: "bouger",
    phonetic: "[bu\u0292e]",
    type: "",
    translation: "v.i. \u52a8\uff1b\u6447\u52a8\uff1b\u79fb\u52a8\uff0c\u79bb\u5f00\uff1b\u51fa\u95e8\uff1bv.t. \u52a8\uff0c\u642c\u52a8\uff0c\u79fb\u52a8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 306,
    word: "placer",
    phonetic: "[plase]",
    type: "",
    translation: "v.t. \u4f7f\u5c31\u5ea7\uff1b\u5b89\u653e\uff1b\u7ed9\u4e88\u2026\u2026\u4f4d\u5b50\uff1b\u6295\u8d44\uff0c\u5b58\u653e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 307,
    word: "saluer",
    phonetic: "[sal\u0265e]",
    type: "",
    translation: "v.t. \u62db\u547c\uff0c\u5411\u2026\u2026\u81f4\u610f\uff1b\u5411\u2026\u2026\u656c\u793c\uff1b\u8fce\u63a5\uff1b\u6b22\u547c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 308,
    word: "m\u00e9tier",
    phonetic: "[metje]",
    type: "",
    translation: "n.m. \u804c\u4e1a\uff1b\u6280\u80fd\uff1b\u884c\u4e1a\uff1b\u624b\u827a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 309,
    word: "autrefois",
    phonetic: "[otr\u0259fwa]",
    type: "",
    translation: "adv. \u8fc7\u53bb\uff0c\u4ee5\u524d\uff0c\u4ece\u524d\uff0c\u5f80\u6614 v.t. \u518d\u653e\u4e0b\uff1b\u91cd\u65b0\u653e\u4e0b\uff1b\u653e\u56de\uff1b\u91cd\u65b0\u5b89\u7f6e\uff0c\u91cd\u65b0\u5b89\u653e\uff1b\u91cd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 310,
    word: "reposer",
    phonetic: "[r\u0259poze]",
    type: "",
    translation: "\u65b0\u63d0\u51fa\uff1bv.i. \u4f11\u606f\uff0c\u7761\uff1b\u5b89\u606f\uff1b\u5efa\u7b51\u5728\uff1b\u5efa\u7acb\u4e8e\uff1b\u4f9d\u9760",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 311,
    word: "coucher",
    phonetic: "[ku\u222be]",
    type: "",
    translation: "v.t. \u4f7f\u4e0a\u5e8a\u7761\u4e0b\uff1b\u4f7f\u8eba\u4e0b\uff1b\u4f7f\u5e73\u653e\uff0c\u628a\u2026\u2026\u653e\u5012",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 312,
    word: "poursuivre",
    phonetic: "[purs\u0265ivr]",
    type: "",
    translation: "v.t. \u8ffd\uff0c\u8ffd\u9010\uff1b\u8ffd\u6355\uff1b\u8ffd\u6c42\uff1b\u7ee7\u7eed\uff1b\u7ea0\u7f20\uff1b[\u6cd5]\u8d77\u8bc9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 313,
    word: "lentement",
    phonetic: "[l\u0251\u0303tm\u0251\u0303]",
    type: "",
    translation: "adv. \u7f13\u6162\u5730\uff0c\u6162\u817e\u817e\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 314,
    word: "douceur",
    phonetic: "[dus\u0153r]",
    type: "",
    translation: "n.f. \u751c\uff1b\u8f7b\u67d4\uff1b\u7f8e\u5999\uff1b\u751c\u871c\uff1b\u6e29\u548c\uff1b\u6e29\u67d4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 315,
    word: "poliment",
    phonetic: "[p\u0254lim\u0251\u0303]",
    type: "",
    translation: "adv. \u793c\u8c8c\u5730\uff0c\u5f6c\u5f6c\u6709\u793c\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 316,
    word: "signifier",
    phonetic: "[si\u0272ifje]",
    type: "",
    translation: "v.t. \u8868\u793a\uff0c\u610f\u5473\u7740\uff1b\u610f\u5373\uff1b\u544a\u77e5\uff0c\u901a\u77e5\uff0c\u5ba3\u544a 9 of 12 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 317,
    word: "champ",
    phonetic: "[\u222b\u0251\u0303]",
    type: "",
    translation: "n.m. \u7530\uff0c\u8015\u5730\uff1b\uff08\u6d3b\u52a8\u3001\u7814\u7a76\u7684\uff09\u8303\u56f4\uff0c\u9886\u57df\uff1b\u89c6\u91ce",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 318,
    word: "inutile",
    phonetic: "[inytil]",
    type: "",
    translation: "a. \u65e0\u7528\u7684\uff0c\u65e0\u5b9e\u7528\u4ef7\u503c\u7684\uff1b\u65e0\u76ca\u7684\uff0c\u65e0\u6548\u7684\uff0c\u5f92\u52b3\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 319,
    word: "marchand",
    phonetic: "[mar\u222b\u0251\u0303, -d]",
    type: "",
    translation: "n. \u5546\u4eba\uff0c\u751f\u610f\u4eba\uff1ba. \u9500\u552e\u7684\uff1b\u5546\u54c1\u7684\uff1b\u5546\u4e1a\u7684\uff1b\u7ecf\u5546\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 320,
    word: "globe",
    phonetic: "[gl\u0254b]",
    type: "",
    translation: "n.m. \u7403\uff0c\u7403\u4f53\uff1b\u5730\u7403\uff1b\u4e16\u754c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 321,
    word: "chapeau",
    phonetic: "[\u222bapo]",
    type: "",
    translation: "n.m. \u5e3d\u5b50\uff1b[\u673a]\u5e3d\uff0c\u76d6\uff0c\u7f69\u5b50 n.m. \u987a\u5e8f\uff0c\u6b21\u5e8f\uff1b\u6574\u9f50\uff1b\u79e9\u5e8f\uff1b\u793e\u4f1a\u79e9\u5e8f\uff1b\u79cd\u7c7b\uff1b\u8303",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 322,
    word: "ordre",
    phonetic: "[\u0254rdr]",
    type: "",
    translation: "\u7574\uff1b\u547d\u4ee4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 323,
    word: "montagne",
    phonetic: "[m\u0254\u0303ta\u0272]",
    type: "",
    translation: "n.f. \u5c71\uff0c\u5c71\u5cb3\uff1b\u5c71\u533a\uff1b\u4e00\u5927\u5806 v.t. \u6ce8\u51fa\uff0c\u6807\u51fa\uff1b\u8bb0\u4e0b\uff0c\u5199\u4e0b\uff1b\u6ce8\u610f\uff0c\u6ce8\u610f\u5230\uff1b\u8bc4\u5206\uff0c\u4e0b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 324,
    word: "noter",
    phonetic: "[n\u0254te]",
    type: "",
    translation: "\u8bc4\u8bed",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 325,
    word: "fournir",
    phonetic: "[furnir]",
    type: "",
    translation: "v.t. \u4f9b\u5e94\uff0c\u4f9b\u7ed9\uff1b\u7ed9\uff1b\u63d0\u4f9b\uff1b\u51fa\u4ea7\uff1b\u4ed8\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 326,
    word: "change",
    phonetic: "[\u222b\u0251\u0303\u0292]",
    type: "",
    translation: "n.m. \u4ea4\u6362\uff0c\u5151\u6362\uff0c\u5916\u6c47\u4ea4\u6613\uff1b\u5916\u6c47\u5151\u6362\u7387",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 327,
    word: "deviner",
    phonetic: "[d\u0259vine]",
    type: "",
    translation: "v.t. \u731c\u5230\uff0c\u731c\u4e2d\uff1b\u731c\u6d4b\uff0c\u63a8\u6d4b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 328,
    word: "craindre",
    phonetic: "[kr\u025b\u0303dr]",
    type: "",
    translation: "v.t. \u62c5\u5fc3\uff1b\u5bb3\u6015\uff1b\u5bf9\u2026\u2026\u654f\u611f\uff1b\u6297\u4e0d\u4f4f\uff0c\u8010\u4e0d\u4f4f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 329,
    word: "autorit\u00e9",
    phonetic: "[ot\u0254rite]",
    type: "",
    translation: "n.f. \u5a01\u4fe1\uff0c\u5a01\u671b\uff1b\u6743\u5a01\u4eba\u58eb\uff1b\u6743\u529b\uff0c\u804c\u6743\uff1b\u6743\u529b\u673a\u5173",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 330,
    word: "chacun",
    phonetic: "[\u222bak\u0153\u0303]",
    type: "",
    translation: "pron.ind\u00e9f. \u5404\u4eba\uff0c\u6bcf\u4e2a\u4eba\uff1b\u6bcf\u4e00\u4e2a\uff1b\u5404\u7269",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 331,
    word: "condition",
    phonetic: "[k\u0254\u0303disj\u0254\u0303]",
    type: "",
    translation: "n.f. \u6761\u4ef6\uff1b\uff08\u793e\u4f1a\uff09\u5730\u4f4d\uff0c\u8eab\u4efd\uff1b\u72b6\u51b5\uff1b\u73af\u5883\uff0c\u5f62\u52bf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 332,
    word: "b\u00eate",
    phonetic: "[b\u03b5t]",
    type: "",
    translation: "n.f. \u517d\uff1b\u755c\u751f\uff1b\u7272\u53e3\uff1ba. \u50bb\u7684\uff0c\u611a\u8822\u7684\uff1b\u7cca\u6d82\u7684\uff1b\u4e0d\u5e78\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 333,
    word: "occup\u00e9",
    phonetic: "[\u0254kype]",
    type: "",
    translation: "a. \u5fd9\u788c\u7684\uff1b\u88ab\u5360\u7528\u7684\uff1b\u6709\u4eba\u9884\u8ba2\u7684\uff1b\u88ab\u5360\u9886\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 334,
    word: "doigt",
    phonetic: "[dwa]",
    type: "",
    translation: "n.m. \u624b\u6307\uff0c\u8db3\u8dbe\uff1b\u4e00\u6307\u7684\u5bbd\u5ea6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 335,
    word: "honte",
    phonetic: "[\u0254\u0303t]",
    type: "",
    translation: "\u865a\u97f3H n.f. \u7f9e\u6127\uff0c\u60ed\u6127\uff1b\u803b\u8fb1\uff0c\u7f9e\u803b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 336,
    word: "addition",
    phonetic: "[adisj\u0254\u0303]",
    type: "",
    translation: "n.f. \u589e\u52a0\uff0c\u589e\u6dfb\uff1b\u589e\u52a0\u7269\uff1b[\u6570]\u52a0\u6cd5\uff1b\uff08\u9910\u9986\u7b49\u7684\uff09\u8d26\u5355",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 337,
    word: "fabriquer",
    phonetic: "[fabrike]",
    type: "",
    translation: "v.t. \u5236\u9020\uff0c\u5236\u4f5c\uff0c\u751f\u4ea7\uff1b\u505a\uff0c\u5e72\uff1b\u4f2a\u9020\uff1b\u7f16\u9020",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 338,
    word: "content",
    phonetic: "[k\u0254\u0303t\u0251\u0303, -t]",
    type: "",
    translation: "a. \u9ad8\u5174\u7684\uff1b\u6ee1\u610f\u7684\uff0c\u6ee1\u8db3\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 339,
    word: "paysage",
    phonetic: "[peiza\u0292]",
    type: "",
    translation: "n.m. \u98ce\u666f\uff0c\u666f\u8272\uff1b\u98ce\u666f\u753b\uff0c\u98ce\u666f\u7167\uff1b\u9762\u8c8c\uff0c\u683c\u5c40",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 340,
    word: "oreille",
    phonetic: "[\u0254r\u03b5j]",
    type: "",
    translation: "n.f. \u8033\uff1b\u542c\u89c9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 341,
    word: "chant",
    phonetic: "[\u222b\u0251\u0303]",
    type: "",
    translation: "n.m. \u6b4c\u5531\uff1b\u6b4c\u58f0\uff1b\u6b4c\u66f2 n.m. \u56de\u97f3\uff0c\u56de\u58f0\uff1b[\u6280]\u56de\u6ce2\uff1b\u6d88\u606f\uff0c\u4f20\u8a00\uff1b\u53cd\u6620\uff1b\u53cd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 342,
    word: "\u00e9cho",
    phonetic: "[eko]",
    type: "",
    translation: "\u54cd\uff0c\u5171\u9e23\uff0c\u54cd\u5e94",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 343,
    word: "poss\u00e9der",
    phonetic: "[p\u0254sede]",
    type: "",
    translation: "v.t. \u62e5\u6709\uff0c\u5360\u6709\uff1b\u5177\u6709\uff1b\u638c\u63e1\uff0c\u7cbe\u901a\uff0c\u719f\u8c19\uff1b\u63a7\u5236\uff0c\u652f\u914d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 344,
    word: "mouton",
    phonetic: "[mut\u0254\u0303]",
    type: "",
    translation: "n.m. \u7f8a\uff0c\u7ef5\u7f8a\uff1b\u7f8a\u8089 adj. \u505a\u597d\u7684\uff0c \u5b8c\u6210\u7684\uff1b \u6210\u529f\u7684\uff0c \u51fa\u8272\u7684\uff1b\u591f\u6210\u529f\u7684\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 345,
    word: "r\u00e9ussi",
    phonetic: "[reysi]",
    type: "",
    translation: "\u591f\u51fa\u8272\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 346,
    word: "dessin",
    phonetic: "[des\u025b\u0303]",
    type: "",
    translation: "n.m. \u7d20\u63cf\uff0c\u56fe\u753b\uff1b\u7ed8\u753b\uff1b\u8f6e\u5ed3\uff0c\u5916\u5f62",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 347,
    word: "ferm\u00e9",
    phonetic: "[f\u03b5rme]",
    type: "",
    translation: "a. \u5c01\u95ed\u7684\uff1b\u5173\u95ed\u7684\uff0c\u5408\u62e2\u7684\uff1b\u4e0d\u7231\u4ea4\u5f80\u7684\uff1b\u4e0d\u5f00\u6717\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 348,
    word: "soif",
    phonetic: "[swaf]",
    type: "",
    translation: "n.f. \u6e34\uff1b\u6e34\u671b\uff0c\u6b32\u671b a. \u8352\u8c2c\u7684\uff0c\u8352\u5510\u7684\uff0c\u8352\u8bde\u7684\uff1b[\u54f2]\u4e0d\u5408\u903b\u8f91\u7684\uff0c\u8fdd\u80cc\u903b\u8f91",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 349,
    word: "absurde",
    phonetic: "[apsyrd]",
    type: "",
    translation: "\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 350,
    word: "faillir",
    phonetic: "[fajir]",
    type: "",
    translation: "v.i. \u51e0\u4e4e\uff0c\u9669\u4e9b\u513f\uff0c\u5dee\u4e00\u70b9\u513f\uff1b\u7f3a\u4e4f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 351,
    word: "foi",
    phonetic: "[fwa]",
    type: "",
    translation: "n.f. \u4fe1\u7528\uff1b\u4fe1\u4ef0\uff0c\u5b97\u6559\u4fe1\u4ef0\uff1b\u4fe1\u4efb\uff0c\u4fe1\u8d56\uff1b\u8bfa\u8a00\uff0c\u4fdd\u8bc1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 352,
    word: "interroger",
    phonetic: "[\u025b\u0303t\u03b5r\u0254\u0292e]",
    type: "",
    translation: "v.t. \u8baf\u95ee\uff1b\u63d0\u95ee\uff1b\u5ba1\u95ee v.t. \u60ac\u6302\uff0c\u540a\u8d77\uff1b\u7ede\u6b7b\uff0c\u540a\u6b7b\uff1bv.i. \u6302\u7740\uff0c\u540a\u7740\uff1b\u4e0b\u5782\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 353,
    word: "pendre",
    phonetic: "[p\u0251\u0303dr]",
    type: "",
    translation: "\u62d6\u4e0b\u6765",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 354,
    word: "sou",
    phonetic: "[su]",
    type: "",
    translation: "n.m. \u82cf\uff1bpl. \u94b1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 355,
    word: "franc",
    phonetic: "[fr\u0251\u0303]",
    type: "",
    translation: "a. \u5766\u7387\u7684\uff0c\u76f4\u7387\u7684\uff1b\u660e\u786e\u7684\uff1b\u514d\u7a0e\u7684\uff1bn.m. \u6cd5\u90ce",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 356,
    word: "crayon",
    phonetic: "[kr\u03b5j\u0254\u0303]",
    type: "",
    translation: "n.m. \u94c5\u7b14\uff1b\u94c5\u7b14\u72b6\u7269 10 of 12 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 357,
    word: "tailler",
    phonetic: "[taje]",
    type: "",
    translation: "v.t. \u5207\u524a\uff0c\u526a\uff0c\u5272\uff1b\u51ff\uff1b\u88c1\u526a\uff1b\u7422\u78e8\uff0c\u4fee\u526a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 358,
    word: "connu",
    phonetic: "[k\u0254ny]",
    type: "",
    translation: "a. \u8ba4\u8bc6\u7684\uff0c\u5df2\u77e5\u7684\uff1b\u8457\u540d\u7684\uff0c\u4f17\u6240\u5468\u77e5\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 359,
    word: "drame",
    phonetic: "[dram]",
    type: "",
    translation: "n.m. \u620f\u5267\uff1b\u6b63\u5267\uff1b\u5267\u672c\uff1b\u60b2\u5267\uff0c\u60e8\u5267\uff0c\u60b2\u60e8\u4e8b\u4ef6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 360,
    word: "plante",
    phonetic: "[pl\u0251\u0303t]",
    type: "",
    translation: "n.f. \u690d\u7269\uff1b\u4f5c\u7269\uff1b\u82b1\u8349",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 361,
    word: "soigneusement",
    phonetic: "[swa\u0272\u00f8zm\u0251\u0303]",
    type: "",
    translation: "adv. \u7ec6\u5fc3\u5730\uff0c\u4ed4\u7ec6\u5730 n. \u987e\u95ee\uff0c\u53c2\u4e8b\uff0c\u53c2\u8d5e\uff1b\u529d\u544a\u8005\uff0c\u5efa\u8bae\u8005\uff1b\u53c2\u8bae\u5458\uff0c\u53c2\u653f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 362,
    word: "conseiller",
    phonetic: "[k\u0254\u0303seje, \u025br]",
    type: "",
    translation: "\u5458\uff1b\u63a8\u4e8b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 363,
    word: "fontaine",
    phonetic: "[f\u0254\u0303t\u03b5n]",
    type: "",
    translation: "n.f. \u6cc9\uff0c\u6cc9\u6c34\uff1b\u55b7\u6cc9\uff0c\u55b7\u6c34\u6c60\uff1b\u6c34\u69fd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 364,
    word: "bonne",
    phonetic: "[b\u0254n]",
    type: "",
    translation: "adj.f. \u597d\u7684\uff1bn.f. \u5973\u4ec6\uff0c\u5973\u4f63",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 365,
    word: "fatigu\u00e9",
    phonetic: "[fatige]",
    type: "",
    translation: "a. \u75b2\u52b3\u7684\uff1b\u663e\u5f97\u75b2\u52b3\u7684\uff1b\u7528\u65e7\u7684\uff0c\u7528\u574f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 366,
    word: "assis",
    phonetic: "[asi, -z]",
    type: "",
    translation: "a. \u5750\u7740\u7684\uff1b\u7a33\u56fa\u7684\uff0c\u7a33\u5b9a\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 367,
    word: "consoler",
    phonetic: "[k\u0254\u0303s\u0254le]",
    type: "",
    translation: "v.t. \u5b89\u6170\uff0c\u6170\u95ee\uff1b\u9f13\u52b1\uff1b\u51cf\u8f7b\uff0c\u4f7f\u7f13\u548c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 368,
    word: "tort",
    phonetic: "[t\u0254r]",
    type: "",
    translation: "n.m. \u8fc7\u9519\uff0c\u9519\u8bef\uff1b\u635f\u5bb3\uff0c\u4f24\u5bb3\uff0c\u635f\u5931 l\u01ceo 1. \u2160 (\u5f62) (\u5e74\u5c81\u5927) vieux, vieil, vieille; \u00e2g\u00e9, e On 373 vieil n'est jamais trop vieux pour apprendre.; ... a. \u865a\u5f31\u7684\uff1b\u6ca1\u6709\u6c14\u529b\u7684\uff1b\u61e6\u5f31\u7684\uff1b\u80fd\u529b\u8584\u5f31\u7684\uff1b\u8106\u5f31",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 369,
    word: "faible",
    phonetic: "[f\u03b5bl]",
    type: "",
    translation: "\u7684\uff0c\u4e0d\u575a\u56fa\u7684\uff1b\u5fae\u5f31\u7684\uff1b\u5fae\u8584\u7684 a. \u5929\u771f\u7684\uff1b\u5e7c\u7a1a\u7684\uff0c\u5934\u8111\u7b80\u5355\u7684\uff1b\u6734\u7d20\u7684\uff1bn. \u5929\u771f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 370,
    word: "na\u00eff",
    phonetic: "[naif, naiv]",
    type: "",
    translation: "\u4eba\uff1b\u5e7c\u7a1a\u7684\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 371,
    word: "utile",
    phonetic: "[ytil]",
    type: "",
    translation: "a. \u6709\u7528\u7684\uff0c\u6709\u76ca\u7684\uff1b\u53ef\u7528\u7684\uff0c\u6709\u6548\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 372,
    word: "chasser",
    phonetic: "[\u222base]",
    type: "",
    translation: "v.t. \u6253\u730e\uff0c\u72e9\u730e\uff1b\u9a71\u9010\uff1b\u89e3\u96c7\uff1b\u9a71\u6563\uff0c\u6d88\u9664",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 373,
    word: "poule",
    phonetic: "[pul]",
    type: "",
    translation: "n.f. \u6bcd\u9e21",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 374,
    word: "int\u00e9ressant",
    phonetic: "[\u025b\u0303ter\u025bs\u0251\u0303]",
    type: "",
    translation: "ou [\u025b\u0303teres\u0251\u0303] a. \u6709\u8da3\u7684\uff1b\u5f15\u4eba\u6ce8\u76ee\u7684\uff1b\u503c\u5f97\u5173\u5fc3\u7684\uff1b\u6709\u5229\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 375,
    word: "bl\u00e9",
    phonetic: "[ble]",
    type: "",
    translation: "n.m. \u5c0f\u9ea6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 376,
    word: "adieu",
    phonetic: "[adj\u00f8]",
    type: "",
    translation: "interj.\uff0c n.m. \u518d\u89c1\uff01\u6c38\u522b\u4e86\uff01 v.t. \uff08\u4f7f\uff09\u7a7a\uff0c\u5012\u7a7a\uff1b\u559d\u5149\uff1b\u5403\u5149\uff1b\u4f7f\u64a4\u51fa\uff0c\u4f7f\u64a4\u79bb\uff1b\u758f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 377,
    word: "vider",
    phonetic: "[vide]",
    type: "",
    translation: "\u6563\uff1b\u6e05\u9664\uff0c\u6392\u7a7a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 378,
    word: "armer",
    phonetic: "[arme]",
    type: "",
    translation: "v.t. \u6b66\u88c5\uff0c\u914d\u5907\u6b66\u5668\uff1b\u88c5\u5907\uff1b\u4e0a\u819b\uff0c \u88c5\u5f39",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 379,
    word: "fleuve",
    phonetic: "[fl\u0153v]",
    type: "",
    translation: "n.m. \u6c5f\uff0c\u6cb3\uff0c\u5ddd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 380,
    word: "rougir",
    phonetic: "[ru\u0292ir]",
    type: "",
    translation: "v.t. \u4f7f\u53d8\u7ea2\uff0c\u67d3\u7ea2\uff1bv.i. \u53d8\u7ea2\uff1b\uff08\u7531\u4e8e\u6fc0\u52a8\u7b49\u800c\uff09\u8138\u7ea2 adv. \u9a6c\u4e0a\uff0c\u8fc7\u4f1a\u513f\uff1b\u4eca\u5929\u4e0b\u5348\uff0c\u4e0b\u5348\uff1b \uff5e...\uff5e \u65f6\u800c\u2026\u65f6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 381,
    word: "tant\u00f4t",
    phonetic: "[t\u0251\u0303to]",
    type: "",
    translation: "\u800c\u2026",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 382,
    word: "exiger",
    phonetic: "[\u03b5gzi\u0292e]",
    type: "",
    translation: "v.t. \u8981\u6c42\uff0c\u5f3a\u5236\u6027\u8981\u6c42\uff1b\u82db\u6c42\uff1b\u9700\u8981",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 383,
    word: "gravement",
    phonetic: "[gravm\u0251\u0303]",
    type: "",
    translation: "adv. \u4e25\u8083\u5730\uff0c \u8ba4\u771f\u5730\uff1b \u5e84\u4e25\u5730\uff1b\u4e25\u91cd\u5730\uff1b \u5371\u9669\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 384,
    word: "calcul",
    phonetic: "[kalkyl]",
    type: "",
    translation: "n.m. 1.\u8ba1\u7b97\uff0c\u7b97\u6570 2.\u4f30\u8ba1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 385,
    word: "grammaire",
    phonetic: "[gram\u03b5r]",
    type: "",
    translation: "n.f. \u8bed\u6cd5\uff1b\u8bed\u6cd5\u5b66\uff1b\u8bed\u6cd5\u4e66",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 386,
    word: "tomb\u00e9",
    phonetic: "[t\u0254\u0303be]",
    type: "",
    translation: "adj. \u843d\u4e0b\u7684, \u6389\u4e0b\u6765\u7684\uff1b\u88ab\u8d2c\u8c2a\u7684, \u88ab\u5e9f\u9edc\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 387,
    word: "papillon",
    phonetic: "[papij\u0254\u0303]",
    type: "",
    translation: "n.m. \u8774\u8776\uff0c\u86fe adj. \u88ab\u5360\u7528\u7684\uff1b\u88ab\u501f\u7528\u7684\uff1b\u5fd9\u788c\u7684\uff1b\u7f79\u75c5\u7684\uff0c\u906d\u53d7\u2026\u7684\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 388,
    word: "pris",
    phonetic: "[pri, -z]",
    type: "",
    translation: "\u5165\u8ff7\u7684\uff1b\u51dd\u7ed3\u7684\uff0c\u7ed3\u51b0\u7684\uff1b\u53d7\u9a97\u4e0a\u5f53\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 389,
    word: "catastrophe",
    phonetic: "[katastr\u0254f]",
    type: "",
    translation: "n.f. \u4e25\u91cd\u707e\u96be\uff1b\u707e\u96be\u6027\u4e8b\u4ef6 adj. \u7184\u706d\u7684\uff1b\u6697\u6de1\u7684\uff0c\u5fae\u5f31\u7684\uff1b\u51cf\u5f31\u7684\uff0c\u6d88\u5931\u7684\uff0c\u706d\u7edd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 390,
    word: "\u00e9teint",
    phonetic: "[et\u025b\u0303]",
    type: "",
    translation: "\u7684\uff1b\u6781\u5ea6\u8870\u5f31\u7684\uff0c\u65e0\u8868\u60c5\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 391,
    word: "puits",
    phonetic: "[p\u0265i]",
    type: "",
    translation: "n.m. \u6c34\u4e95\uff1b\uff08\u7ad6\uff09\u5751\uff1b\u77ff\u4e95",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 392,
    word: "serpent",
    phonetic: "[s\u03b5rp\u0251\u0303]",
    type: "",
    translation: "n.m. \u86c7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 393,
    word: "contrer",
    phonetic: "[k\u0254\u0303tre]",
    type: "",
    translation: "v. [\u724c\u620f]\u52a0\u500d\uff1b\u53cd\u5bf9\uff0c\u963b\u788d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 394,
    word: "oubli\u00e9",
    phonetic: "[ublije]",
    type: "",
    translation: "adj. \u88ab\u9057\u5fd8\u7684 11 of 12 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 395,
    word: "disparition",
    phonetic: "[disparisj\u0254\u0303]",
    type: "",
    translation: "n.f. \u6d88\u5931\uff1b\u5931\u8e2a\uff1b\u9057\u5931\uff1b\u6d88\u4ea1\uff0c\u706d\u4ea1\uff0c\u706d\u7edd\uff1b\u6b7b\u4ea1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 396,
    word: "habill\u00e9",
    phonetic: "[abije]",
    type: "",
    translation: "adj. \u7a7f\u7740\u8863\u670d\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 397,
    word: "favorable",
    phonetic: "[fav\u0254rabl]",
    type: "",
    translation: "a. \u597d\u610f\u7684\uff1b\u8d5e\u6210\u7684\uff0c\u652f\u6301\u7684\uff1b\u6709\u5229\u7684\uff1b\u6709\u4fc3\u8fdb\u4f5c\u7528\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 398,
    word: "voyageur",
    phonetic: "[vwaja\u0292\u0153r]",
    type: "",
    translation: "n. \u65c5\u884c\u8005\uff1b\u65c5\u5ba2\uff0c\u4e58\u5ba2\uff1b\u65c5\u884c\u5bb6\uff1b\u6e38\u5ba2 v.i. \u4f4e\u6c89\u7684\u55e5\u53eb\uff1b\u53d1\u51fa\u9686\u9686\u58f0\uff1b\u6012\u543c\uff1b\u4f4e\u58f0\u62b1\u6028\uff1bv.t.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 399,
    word: "gronder",
    phonetic: "[gr\u0254\u0303de]",
    type: "",
    translation: "\uff08\u5bf9\u5b69\u5b50\uff09\u8bad\u65a5\uff0c\u8d23\u9a82",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 400,
    word: "seau",
    phonetic: "[so]",
    type: "",
    translation: "n.m. \u6c34\u6876\uff1b\u6876\uff1b\u4e00\u6876\u4e4b\u91cf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 401,
    word: "compris",
    phonetic: "[k\u0254\u0303pri, -z]",
    type: "",
    translation: "a. \u5305\u62ec\u5728\u5185\u7684\uff1b\u7406\u89e3\u7684\uff0c\u61c2\u4e86\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 402,
    word: "graine",
    phonetic: "[gr\u03b5n]",
    type: "",
    translation: "n.f. \u79cd\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 403,
    word: "grandiose",
    phonetic: "[gr\u0251\u0303djoz]",
    type: "",
    translation: "a. \u4f1f\u5927\u7684\uff0c\u5b8f\u4f1f\u7684\uff0c\u96c4\u4f1f\u7684\uff1b\u58ee\u4e3d\u7684\uff0c\u58ee\u89c2\u7684\uff1b\u5d07\u9ad8\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 404,
    word: "volcan",
    phonetic: "[v\u0254lk\u0251\u0303]",
    type: "",
    translation: "n.m. \u706b\u5c71",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 405,
    word: "\u00e9pine",
    phonetic: "[epin]",
    type: "",
    translation: "n.f.\uff08\u690d\u7269\u7684\uff09\u523a\uff0c\u68d8\uff1b\uff08\u67d0\u4e9b\u52a8\u7269\u7684\uff09\u523a\uff0c\u58f3\u9488 n.m. \u5b97\u6559\u4eea\u5f0f\uff1b\u793c\u4eea\uff0c\u793c\u8282\uff1b\u4eea\u5f0f\uff0c\u5178\u793c\uff1b\u5e38\u89c4\uff1b\u4e60",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 406,
    word: "rite",
    phonetic: "[rit]",
    type: "",
    translation: "\u4fd7\uff0c\u60ef\u4f8b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 407,
    word: "b\u00e2iller",
    phonetic: "[b\u0251je]",
    type: "",
    translation: "v.i. \u6253\u5475\u6b20\uff1b\u534a\u5f00\uff0c\u5fae\u5f00\uff1b\u672a\u5173\u4e25\uff0c\u672a\u5173\u7d27",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 408,
    word: "marteau",
    phonetic: "[marto]",
    type: "",
    translation: "n.m. \u9524\u5b50\uff1b\u95e8\u73af v.t.\uff0c v.pr. \u4f7f\u70e6\u607c\uff0c\u4f7f\u64cd\u5fc3\uff1b\u64cd\u52b3\uff0c\u82e6\u5e72\uff0c\u75b2\u4e8e\uff1b\u82b1\u6c14",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 409,
    word: "peiner",
    phonetic: "[p\u03b5ne]",
    type: "",
    translation: "\u529b\uff0c\u52aa\u529b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 410,
    word: "d\u00e9courag\u00e9",
    phonetic: "[dekura\u0292e]",
    type: "",
    translation: "a.\u6cc4\u6c14\u7684\uff0c\u6cae\u4e27\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 411,
    word: "d\u00e9couvert",
    phonetic: "[dekuv\u03b5r, -t]",
    type: "",
    translation: "a. \u66b4\u9732\u7684\uff0c\u65e0\u906e\u76d6\u7684\uff1bn.m. \u900f\u652f\u91d1\u989d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 412,
    word: "cons\u00e9quent",
    phonetic: "[k\u0254\u0303sek\u0251\u0303]",
    type: "",
    translation: "a. \u59cb\u7ec8\u4e0d\u6e1d\u7684\uff0c\u4e00\u8d2f\u7684\uff1b\u91cd\u8981\u7684\uff0c\u91cd\u5927\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 413,
    word: "trouv\u00e9",
    phonetic: "[truve]",
    type: "",
    translation: "adj. \u62fe\u5230\u7684\uff0c \u6361\u6765\u7684\uff1b\u5f88\u6070\u5f53\u7684\uff0c \u7edd\u5999\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 414,
    word: "r\u00e9verb\u00e8re",
    phonetic: "[rev\u03b5rb\u03b5r]",
    type: "",
    translation: "n.m. \u53cd\u5c04\u955c\uff1b\u8def\u706f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 415,
    word: "rallumer",
    phonetic: "[ralyme]",
    type: "",
    translation: "v.t. \u91cd\u65b0\u70b9\u71c3\uff1b\u91cd\u65b0\u5524\u8d77\uff0c\u91cd\u65b0\u6fc0\u8d77\uff0c\u91cd\u65b0\u5f15\u8d77 v.t. \u9a6f\u517b\uff0c\u9a6f\u5316\uff0c\u9a6f\u670d\uff08\u52a8\u7269\uff09\uff1b\u4f7f\u987a\u4ece\uff0c\u4f7f\u542c\u8bdd\uff0c\u4f7f\u53d8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 416,
    word: "apprivoiser",
    phonetic: "[aprivwaze]",
    type: "",
    translation: "\u5f97\u5bb9\u6613\u63a5\u8fd1[\u6307\u4eba]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 417,
    word: "moi",
    phonetic: "[mwa]",
    type: "",
    translation: "pron.pers. \u6211\uff1b \u81ea\u6211 v.t.\uff0c v.pr. [\u56ed\u827a]\u57f9\u571f\uff0c \u58c5\u571f\uff1b\uff08\u52a8\u7269\uff09\u8eb2\u8fdb\u6d1e\u7a74\uff0c\u4f4f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 418,
    word: "terrer",
    phonetic: "[t\u03b5re]",
    type: "",
    translation: "\u5728\u5730\u5e95\u4e0b\uff1b\u8eb2\u85cf\uff1b\u3008\u519b\u4e8b\u3009\u9690\u853d a. \u5b89\u7136\u8131\u9669\u7684\uff0c\u5e73\u5b89\u7684\uff0c\u5b89\u5168\u7684\uff1b\u672a\u53d7\u635f\u5bb3\u7684\uff0c\u88ab\u4fdd\u5168",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 419,
    word: "sauf",
    phonetic: "[sof]",
    type: "",
    translation: "\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 420,
    word: "arbuste",
    phonetic: "[arbyst]",
    type: "",
    translation: "n.m. \u5c0f\u704c\u6728\uff1b\u5c0f\u77ee\u6811 n.m. \u5149\uff0c\u5149\u8292\uff1b[\u7269]\u8f90\u5c04\uff0c\u653e\u5c04\uff0c\u53d1\u5c04\uff1b\u8f90\u5c04\u80fd\uff1b\u5149",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 421,
    word: "rayonnement",
    phonetic: "[r\u03b5j\u0254nm\u0251\u0303]",
    type: "",
    translation: "\u8f89\uff0c\u5a01\u671b\uff1b\u5f71\u54cd\uff0c\u4f20\u64ad",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 422,
    word: "grelot",
    phonetic: "[gr\u0259lo]",
    type: "",
    translation: "n.m. \u94c3\uff0c\u94c3\u94db",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 423,
    word: "fl\u00e2ner",
    phonetic: "[fl\u0251ne]",
    type: "",
    translation: "v.i. \u95f2\u901b\uff0c\u95f2\u8361\uff1b\u5077\u61d2\uff0c\u6e38\u624b\u597d\u95f2\uff0c\u65e0\u6240\u4e8b\u4e8b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 424,
    word: "p\u00e9tale",
    phonetic: "[petal]",
    type: "",
    translation: "n.m. \u82b1\u74e3 12 of 12",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
];
